// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes swing {
  0%, 30%, 50%, 70%, 100% {
    transform: rotate(0deg);
  }
  10% {
    transform: rotate(10deg);
  }
  40% {
    transform: rotate(-10deg);
  }
  60% {
    transform: rotate(5deg);
  }
  80% {
    transform: rotate(-5deg);
  }
}
.pro-sidebar {
  color: #adadad;
  height: 100%;
  width: 270px;
  min-width: 270px;
  text-align: left;
  transition: width, left, right, 0.3s;
  position: relative;
  z-index: 1009;
}
.pro-sidebar > .pro-sidebar-inner {
  background: #1d1d1d;
  height: 100%;
  position: relative;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > img.sidebar-bg {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: center;
  position: absolute;
  opacity: 0.3;
  left: 0;
  top: 0;
  z-index: 100;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
  z-index: 101;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-header {
  border-bottom: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-content {
  flex-grow: 1;
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout .pro-sidebar-footer {
  border-top: 1px solid rgba(173, 173, 173, 0.2);
}
.pro-sidebar > .pro-sidebar-inner > .pro-sidebar-layout ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
.pro-sidebar .overlay {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 100;
  display: none;
}
.pro-sidebar.collapsed {
  width: 80px;
  min-width: 80px;
}
.pro-sidebar.rtl {
  text-align: right;
  direction: rtl;
}
@media (max-width: 480px) {
  .pro-sidebar.xs {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xs.collapsed {
    left: -80px;
  }
  .pro-sidebar.xs.toggled {
    left: 0;
  }
  .pro-sidebar.xs.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xs.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xs.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xs.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 576px) {
  .pro-sidebar.sm {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.sm.collapsed {
    left: -80px;
  }
  .pro-sidebar.sm.toggled {
    left: 0;
  }
  .pro-sidebar.sm.toggled .overlay {
    display: block;
  }
  .pro-sidebar.sm.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.sm.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.sm.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 768px) {
  .pro-sidebar.md {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.md.collapsed {
    left: -80px;
  }
  .pro-sidebar.md.toggled {
    left: 0;
  }
  .pro-sidebar.md.toggled .overlay {
    display: block;
  }
  .pro-sidebar.md.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.md.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.md.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 992px) {
  .pro-sidebar.lg {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.lg.collapsed {
    left: -80px;
  }
  .pro-sidebar.lg.toggled {
    left: 0;
  }
  .pro-sidebar.lg.toggled .overlay {
    display: block;
  }
  .pro-sidebar.lg.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.lg.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.lg.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1200px) {
  .pro-sidebar.xl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xl.toggled {
    left: 0;
  }
  .pro-sidebar.xl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xl.rtl.toggled {
    left: auto;
    right: 0;
  }
}
@media (max-width: 1600px) {
  .pro-sidebar.xxl {
    position: fixed;
    left: -270px;
  }
  .pro-sidebar.xxl.collapsed {
    left: -80px;
  }
  .pro-sidebar.xxl.toggled {
    left: 0;
  }
  .pro-sidebar.xxl.toggled .overlay {
    display: block;
  }
  .pro-sidebar.xxl.rtl {
    left: auto;
    right: -270px;
  }
  .pro-sidebar.xxl.rtl.collapsed {
    left: auto;
    right: -80px;
  }
  .pro-sidebar.xxl.rtl.toggled {
    left: auto;
    right: 0;
  }
}

.pro-sidebar .pro-menu.submenu-bullets .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  content: "";
  display: inline-block;
  width: 4px;
  min-width: 4px;
  height: 4px;
  border: 1px solid #2b2b2b;
  border-radius: 50%;
  margin-right: 15px;
  position: relative;
  box-shadow: 1px 0px 0px #adadad, 0px -1px 0px #adadad, 0px 1px 0px #adadad, -1px 0px 0px #adadad;
}

.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pro-sidebar .pro-menu {
  padding-top: 10px;
  padding-bottom: 10px;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item {
  position: relative;
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu > ul > .pro-sub-menu > .pro-inner-list-item > div > ul {
  padding-top: 15px;
  padding-bottom: 15px;
}
.pro-sidebar .pro-menu a {
  text-decoration: none;
  color: #adadad;
}
.pro-sidebar .pro-menu a:before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: transparent;
}
.pro-sidebar .pro-menu a:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item {
  font-size: 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.active {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item .suffix-wrapper {
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item .prefix-wrapper {
  display: flex;
  margin-right: 5px;
  opacity: 1;
  transition: opacity 0.2s;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item {
  position: relative;
  display: flex;
  align-items: center;
  padding: 8px 35px 8px 20px;
  cursor: pointer;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:focus {
  outline: none;
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 10px;
  font-size: 14px;
  width: 35px;
  min-width: 35px;
  height: 35px;
  line-height: 35px;
  text-align: center;
  display: inline-block;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper .pro-icon {
  display: flex;
  height: 100%;
  align-items: center;
  justify-content: center;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item > .pro-item-content {
  flex-grow: 1;
  flex-shrink: 1;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover {
  color: #d8d8d8;
}
.pro-sidebar .pro-menu .pro-menu-item > .pro-inner-item:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item:before {
  background: #adadad;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  display: inline-block;
  border-style: solid;
  border-color: #adadad;
  border-width: 0 2px 2px 0;
  padding: 2.5px;
  vertical-align: middle;
  transition: transform 0.3s;
  transform: rotate(-45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item:before {
  background: transparent !important;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 24px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 15px;
}
.pro-sidebar .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item > .pro-icon-wrapper {
  background: none;
  width: auto;
  min-width: auto;
  height: auto;
  line-height: auto;
}
.pro-sidebar .pro-menu:not(.inner-submenu-arrows) .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar .pro-menu.shaped .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  background-color: #2b2b2b;
}
.pro-sidebar .pro-menu.square .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 0;
}
.pro-sidebar .pro-menu.round .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 4px;
}
.pro-sidebar .pro-menu.circle .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  border-radius: 50%;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .suffix-wrapper,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-item > .prefix-wrapper {
  opacity: 0;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item > .pro-inner-list-item {
  background-color: #2b2b2b;
  z-index: 111;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item::before {
  content: "";
  display: inline-block;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  cursor: pointer;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu {
  position: relative;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item {
  pointer-events: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  display: none;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  height: auto !important;
  position: fixed;
  visibility: hidden;
  min-width: 220px;
  max-width: 270px;
  background-color: transparent;
  max-height: 100%;
  padding-left: 3px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-left: 10px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  max-height: 100vh;
  overflow-y: auto;
  background-color: #2b2b2b;
  padding-left: 20px;
  border-radius: 4px;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover > .pro-inner-list-item {
  transition: visibility, transform 0.3s;
  visibility: visible;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu:hover .pro-icon-wrapper .pro-icon {
  animation: swing ease-in-out 0.5s 1 alternate;
}
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 30px 8px 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item .prefix-wrapper {
  margin-right: 0;
  margin-left: 5px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item {
  padding: 8px 20px 8px 35px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item > .pro-inner-item > .pro-icon-wrapper {
  margin-right: 0;
  margin-left: 10px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper {
  right: auto;
  left: 20px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(135deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu.open > .pro-inner-item > .pro-arrow-wrapper .pro-arrow {
  transform: rotate(45deg);
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item {
  padding-left: 0;
  padding-right: 24px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 15px 8px 30px;
}
.pro-sidebar.rtl .pro-menu .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item:before {
  margin-right: 0;
  margin-left: 15px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item {
  padding-left: 0;
  padding-right: 3px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item.has-arrow {
  padding-right: 10px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu > .pro-inner-list-item > .popper-inner {
  padding-left: 0;
  padding-right: 20px;
}
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-sub-menu-item,
.pro-sidebar.rtl.collapsed .pro-menu > ul > .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {
  padding: 8px 5px 8px 30px;
}

.popper-arrow {
  position: absolute;
  z-index: -1;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-bottom: 7px solid transparent;
}

.popper-element[data-popper-placement^=left] > .popper-arrow {
  right: 0;
  border-right: 7px solid #2b2b2b;
}

.popper-element[data-popper-placement^=right] > .popper-arrow {
  left: 0;
  border-left: 7px solid #2b2b2b;
}

.react-slidedown {
  height: 0;
  transition-property: none;
  transition-duration: 0.2s;
  transition-timing-function: ease-in-out;
}

.react-slidedown.transitioning {
  overflow-y: hidden;
}

.react-slidedown.closed {
  display: none;
}

div.ruby-menu-demo-header {
  position: relative;
  left: 0;
  top: 0;
  width: 100%;
  height: auto;
  padding: 0;
  margin: 0;
  z-index: 99999;
}

.menu-mob {
  display: none;
}

.padding_set_nav {
  padding-top: 2%;
  padding-bottom: 5% !important;
}

.fontSizejoin {
  border: 1px dashed gray;
  border-top-left-radius: 1px;
  border-top-right-radius: 15px;
  border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;
}

.card_background_color {
  background-color: #ECEDFF;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 20px;
  border-bottom-left-radius: 20px;
}

.background_color_button {
  background-color: #DCDFFF;
  border: #DCDFFF;
  color: #0575E6;
}

.bg_nav_white {
  background-color: white;
  transition: 0.9s;
}

.padding_custom {
  padding-left: 8% !important;
  padding-right: 8% !important;
}

div.ruby-menu-demo-header-bg div.ruby-menu-demo-download > span {
  color: #efefef;
}

div.ruby-menu-demo-header-bg div.ruby-menu-demo-download > span > span {
  color: #efefef;
}

div.ruby-menu-demo-description {
  position: relative;
  width: 980px;
  height: 160px;
  margin: 0 auto;
  padding: 0;
}

div.ruby-menu-demo-description img {
  max-width: 200px;
  float: left;
  margin: 50px 20px 0 0;
}

span.ruby-menu-demo-highlight {
  color: #333;
}

div.ruby-menu-demo-bg-light, div.ruby-menu-demo-bg-dark {
  width: 980px;
  height: auto;
  position: relative;
  background: #fff;
  margin: 0 auto;
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
}

div.ruby-menu-demo-bg-dark {
  background: efefef;
}

div.ruby-menu-demo-bg-light-c:after, div.ruby-menu-demo-bg-dark-c:after {
  content: "";
  display: table;
  clear: both;
}

div.ruby-menu-demo-cv-1 {
  float: left;
  width: 33%;
}

div.ruby-menu-demo-cv-2 {
  float: left;
  width: 67%;
}

div.ruby-menu-demo-cv-3 {
  float: left;
  width: 48%;
}

div.ruby-menu-demo-cv-4 {
  float: left;
  width: 52%;
}

div.ruby-menu-demo-cr-1 {
  float: left;
  width: 33%;
}

div.ruby-menu-demo-cr-2 {
  float: left;
  width: 66%;
}

div.ruby-menu-demo-cs-1 {
  float: left;
  width: 33%;
}

div.ruby-menu-demo-cs-2 {
  float: left;
  width: 66%;
}

div.ruby-menu-demo-cf-1, div.ruby-menu-demo-cf-2, div.ruby-menu-demo-cf-3, div.ruby-menu-demo-cf-4 {
  float: left;
  width: 25%;
  text-align: center;
}

div.ruby-menu-demo-f-icon {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin: 0 auto;
  padding: 22px;
  font-size: 30px;
  background: #efefef;
  color: #aaa;
}

div.ruby-menu-demo-f-title {
  width: 100%;
  height: 30px;
  margin: 0 auto;
  margin-top: 20px;
  font-weight: 700;
  font-size: 18px;
}

div.ruby-menu-demo-f-desc {
  font-size: 14px;
  line-height: 24px;
  color: #555;
  padding: 15px;
}

div.ruby-menu-demo-cs-1 table {
  line-height: 20px;
}

div.ruby-menu-demo-cs-1 table tr, div.ruby-menu-demo-cs-1 table td {
  padding: 0;
  font-weight: 700;
}

div.ruby-menu-demo-cs-1 table td:last-child {
  padding-top: 5px;
}

h2.ruby-menu-demo-slogan-1, h3.ruby-menu-demo-slogan-1 {
  font-size: 20px;
  font-weight: 300;
  text-transform: uppercase;
  color: #b1b1b1;
  margin: 0;
}

h1.ruby-menu-demo-slogan-2, h3.ruby-menu-demo-slogan-2 {
  font-size: 36px;
  font-weight: 700;
  text-transform: none;
  color: #222;
  margin: 0;
}

p.ruby-menu-demo-slogan-description, p.ruby-menu-demo-slogan-description-2 {
  font-size: 16px;
  line-height: 24px;
  color: #444;
  margin: 35px 0;
}

p.ruby-menu-demo-slogan-description-2 {
  color: #666;
  font-weight: 600;
  margin: -10px 0;
}

span.ruby-menu-demo-code {
  color: #888;
  text-decoration: underline;
}

td.ruby-menu-demo-theme-td-1 {
  max-width: 30px;
  text-align: left;
  padding: 6px;
}

td.ruby-menu-demo-theme-td-2 {
  min-width: 120px;
  text-align: left;
  padding: 6px;
}

td.ruby-menu-demo-theme-td-1:hover {
  cursor: pointer;
}

.ruby-menu-demo-circle {
  border-radius: 50%;
  width: 24px;
  height: 24px;
  border: 4px solid #222;
  display: inline-block;
  margin: 0;
}

.ruby-menu-demo-color-1 {
  background: #1aad86;
}

.ruby-menu-demo-color-2 {
  background: #0c67c2;
}

.ruby-menu-demo-color-3 {
  background: #ce0661;
}

.ruby-menu-demo-color-4 {
  background: #ea7500;
}

.ruby-menu-demo-color-5 {
  background: #74ba27;
}

.ruby-menu-demo-color-6 {
  background: #ff3264;
}

.ruby-menu-demo-color-7 {
  background: #fad814;
}

.ruby-menu-demo-color-8 {
  background: #ccc;
}

.ruby-menu-demo-color-9 {
  background: #111;
  border-color: #ccc;
}

.ruby-menu-demo-color-10 {
  background: #036de2;
  border-color: #489efd;
}

.ruby-menu-demo-color-11 {
  background: #f85252;
  border-color: #444;
}

.ruby-menu-demo-color-12 {
  background: #ca79d0;
  border-color: #f2def3;
}

.ruby-menu-demo-color-13 {
  background: #efefef;
  border-color: #222;
}

.ruby-menu-demo-color-14 {
  background: #ccc;
}

div.ruby-menu-demo-download {
  position: absolute;
  width: auto;
  top: 55px;
  right: 0;
}

div.ruby-menu-demo-download .fa {
  font-size: 20px;
  margin-right: 10px;
}

div.ruby-menu-demo-download > span {
  font-size: 16px;
  display: block;
  margin: 10px 26px;
}

div.ruby-menu-demo-download > span > span {
  font-size: 20px;
  color: #555;
  font-weight: 700;
}

button.ruby-btn {
  background: #19ad86;
  border: 2px solid #19ad86;
  color: #fff;
  border-radius: 0;
  padding: 10px 25px;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
}

button.ruby-btn:hover {
  background: #fff;
  color: #19ad86;
}

.switch {
  display: table-cell;
  vertical-align: middle;
  padding: 10px;
}

.cmn-toggle {
  position: absolute;
  margin-left: -9999px;
  visibility: hidden;
}

.cmn-toggle + label {
  display: block;
  position: relative;
  cursor: pointer;
  outline: none;
  -webkit-user-select: none;
  user-select: none;
}

input.cmn-toggle-round + label {
  padding: 2px;
  margin-top: -10px;
  width: 40px;
  height: 20px;
  background-color: #ddd;
  border-radius: 20px;
}

input.cmn-toggle-round + label:before, input.cmn-toggle-round + label:after {
  display: block;
  position: absolute;
  top: 1px;
  left: 1px;
  bottom: 1px;
  content: "";
}

input.cmn-toggle-round + label:before {
  right: 1px;
  background-color: #f1f1f1;
  border-radius: 20px;
  transition: background 0.4s;
}

input.cmn-toggle-round + label:after {
  width: 18px;
  background-color: #fff;
  border-radius: 100%;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: margin 0.4s;
}

input.cmn-toggle-round:checked + label:before, input.cmn-toggle-on + label:before {
  background-color: #8ce196;
}

input.cmn-toggle-round:checked + label:after, input.cmn-toggle-on + label:after {
  margin-left: 20px;
}

input.cmn-toggle-on:checked + label:before {
  background-color: #f1f1f1;
}

input.cmn-toggle-on:checked + label:after {
  margin-left: 0;
}

img.iphone7 {
  max-width: 350px;
  float: right;
  margin-right: 0;
}

@media (min-width: 768px) and (max-width: 991px) {
  body {
    overflow-x: hidden;
  }
  div.ruby-menu-demo-description {
    position: relative;
    width: 760px;
    height: 160px;
    margin: 0 auto;
    padding: 0;
  }
  div.ruby-menu-demo-description img {
    max-width: 200px;
    float: left;
    margin: 50px 20px 0 0;
  }
  div.ruby-menu-demo-bg-light, div.ruby-menu-demo-bg-dark {
    width: 760px;
    font-size: 14px;
  }
  div.ruby-menu-demo-cs-1 {
    width: 27%;
  }
  div.ruby-menu-demo-cs-2 {
    width: 73%;
  }
  td.ruby-menu-demo-theme-td-1 {
    max-width: 27px;
    padding: 7px;
  }
  td.ruby-menu-demo-theme-td-2 {
    min-width: 100px;
    padding: 7px;
  }
  .ruby-menu-demo-circle {
    width: 22px;
    height: 22px;
    border: 3px solid #222;
  }
  img.iphone7 {
    max-width: 320px;
    float: right;
    margin-right: 20px;
  }
}
@media (max-width: 767px) {
  div.ruby-menu-demo-header {
    width: 100%;
    height: auto;
  }
  div.ruby-menu-demo-description {
    width: 100%;
    margin: 0 auto;
    margin-bottom: 220px;
    padding: 10px;
    text-align: center;
  }
  div.ruby-menu-demo-description img {
    float: none;
    margin: 90px 0 0;
  }
  div.ruby-menu-demo-download {
    position: relative;
    width: auto;
    top: 25px;
    right: auto;
    left: auto;
  }
  div.ruby-menu-demo-download > span {
    font-size: 20px;
    margin: 25px auto;
  }
  div.ruby-menu-demo-download > span > span {
    font-size: 26px;
  }
  button.ruby-btn {
    padding: 14px 25px;
    font-size: 16px;
    text-transform: uppercase;
  }
  div.ruby-menu-demo-bg-light.ruby-menu-demo-switches {
    display: none;
  }
  div.ruby-menu-demo-bg-light, div.ruby-menu-demo-bg-dark {
    width: 100%;
    font-size: 16px;
    padding: 25px;
    margin-bottom: -100px;
  }
  div.ruby-menu-demo-cv-1 {
    width: 100%;
  }
  div.ruby-menu-demo-cv-2 {
    width: 100%;
  }
  div.ruby-menu-demo-cv-3 {
    width: 100%;
  }
  div.ruby-menu-demo-cv-4 {
    width: 100%;
  }
  div.ruby-menu-demo-cr-1 {
    width: 100%;
  }
  div.ruby-menu-demo-cr-2 {
    width: 100%;
    margin-top: 40px;
  }
  div.ruby-menu-demo-cf-1, div.ruby-menu-demo-cf-2, div.ruby-menu-demo-cf-3, div.ruby-menu-demo-cf-4 {
    float: left;
    width: 50%;
    text-align: center;
  }
  div.ruby-menu-demo-f-desc {
    margin-bottom: 30px;
  }
  img.iphone7 {
    max-width: 300px;
    float: none;
    margin-right: 0 auto;
  }
}
/* theme */
div.ruby-wrapper, div.ruby-wrapper.ruby-vertical {
  background: #f9f9f9;
  color: #222;
}

ul.ruby-menu > li > a {
  color: #222;
}

ul.ruby-menu > li > a:hover, ul.ruby-menu > li:hover > a, ul.ruby-menu > li.ruby-active-menu-item > a:hover, ul.ruby-menu > li.ruby-active-menu-item:hover > a {
  background: #222;
  color: #212530;
}

ul.ruby-menu > li.ruby-active-menu-item > a {
  background: #efefef;
  color: #222;
}

ul.ruby-menu.ruby-menu-dividers > li > a, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social > a {
  border-left: 1px solid #ddd;
  border-right: 1px solid #fff;
}

ul.ruby-menu.ruby-menu-dividers > li:first-child > a, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social:last-child > a {
  border-left: none;
}

ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li > a {
  border: none;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #fff;
}

ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li:first-child > a {
  border-top: none;
}

ul.ruby-menu.ruby-menu-dividers > li > a:hover, ul.ruby-menu.ruby-menu-dividers > li:hover > a {
  border-left: 1px solid #222;
  border-right: 1px solid #222;
}

ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li > a:hover, ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li:hover > a {
  border-bottom: 1px solid #222;
}

ul.ruby-menu.ruby-menu-dividers > li.ruby-active-menu-item > a {
  border-left: 1px solid #efefef;
  border-right: 1px solid #fff;
}

ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li.ruby-active-menu-item > a {
  border-bottom: 1px solid #fff;
  border-left: none;
  border-right: none;
}

ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li > a {
  border-left: none;
  border-right: none;
}

ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li.ruby-active-menu-item > a:hover, ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li.ruby-active-menu-item:hover > a {
  border-bottom: 1px solid #222;
  border-left: none;
}

ul.ruby-menu > li > ul, ul.ruby-menu > li > ul > li > ul, ul.ruby-menu > li > ul > li > ul > li > ul {
  border-top: 4px solid #222;
}

ul.ruby-menu > li > ul > li > a, ul.ruby-menu > li > ul > li > ul > li > a, ul.ruby-menu > li > ul > li > ul > li > ul > li > a {
  background: #fff;
  color: #666;
}

ul.ruby-menu > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > a:hover, ul.ruby-menu > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > a:hover, ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {
  background: #efefef;
}

ul.ruby-menu > li.ruby-menu-mega > div, ul.ruby-menu > li.ruby-menu-mega-blog > div, ul.ruby-menu > li.ruby-menu-mega-shop > div {
  background: #fff;
  border-top: 4px solid #222;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav {
  background: #efefef;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a {
  background: #efefef;
  color: #666;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a {
  background: #e6e6e6;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {
  background: #fff;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a {
  background: #ddd;
}

ul.ruby-menu > li.ruby-menu-mega-shop > div > ul {
  background: #efefef;
  border-bottom: 1px solid #ddd;
}

ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {
  color: #666;
}

ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div {
  background: #fff;
}

ul.ruby-menu > li.ruby-menu-mega > div ul li > a, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li > a {
  color: #555;
}

ul.ruby-menu > li.ruby-menu-mega > div ul li > a:hover, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li > a:hover {
  color: #222;
}

ul.ruby-menu > li.ruby-menu-mega > div ul.ruby-list-with-images li span.ruby-list-desc {
  color: #999;
}

span.ruby-c-title, span.ruby-c-title a {
  color: #222;
}

span.ruby-c-title a:hover, span.ruby-c-category, span.ruby-c-category a, span.ruby-c-date, span.ruby-c-date a {
  color: #444;
}

span.ruby-c-category a:hover, span.ruby-c-date a:hover {
  color: #222;
}

@media (min-width: 768px) {
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:after {
    background-color: #222;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover {
    color: #333;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a:after, ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a:after {
    border-color: transparent #fff transparent transparent;
  }
}
@media (max-width: 767px) {
  ul.ruby-menu > li > a {
    background: #efefef;
  }
  ul.ruby-menu > li > a:hover, ul.ruby-menu > li:hover > a, ul.ruby-menu > li.ruby-active-menu-item > a:hover {
    background: #ccc;
    color: #111;
  }
  ul.ruby-menu > li.ruby-active-menu-item > a {
    background: #ccc;
  }
  ul.ruby-menu > li > ul > li > a, ul.ruby-menu > li > ul > li > ul > li > a, ul.ruby-menu > li > ul > li > ul > li > ul > li > a, ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {
    background: #d1d1d1;
  }
  ul.ruby-menu > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > a:hover, ul.ruby-menu > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > a:hover, ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {
    background: #d9d9d9;
    color: #111;
  }
  ul.ruby-menu > li > ul > li > ul > li > a {
    background: #e5e5e5;
  }
  ul.ruby-menu > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > a:hover {
    background: #e1e1e1;
  }
  ul.ruby-menu > li > ul > li > ul > li > ul > li > a {
    background: #efefef;
  }
  ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {
    background: #fff;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a {
    background: #bcbcbc;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a {
    background: #d9d9d9;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a {
    background: #bcbcbc;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > a, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a {
    background: #d9d9d9;
  }
  span.ruby-dropdown-toggle:after {
    color: #fff;
  }
  ul.ruby-menu > li > a:before, ul.ruby-menu > li > ul > li > a:before, ul.ruby-menu > li > ul > li > ul > li > a:before, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:before, ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a:before, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before {
    background: #333;
  }
  ul.ruby-menu > li > ul > li > a:before, ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a:before, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before {
    background: #555;
  }
  ul.ruby-menu > li > ul > li > ul > li > a:before {
    background: #777;
  }
  ul.ruby-menu > li > ul > li > ul > li > ul > li > a:before {
    background: #999;
  }
  .c-hamburger span {
    background: #222;
  }
  .c-hamburger span::before, .c-hamburger span::after {
    background-color: #222;
  }
  .c-hamburger--htx {
    background-color: #efefef;
    color: #222;
  }
  .c-hamburger--htx.is-active {
    background-color: #ddd;
  }
  ul.ruby-menu > li.ruby-menu-mega > div, ul.ruby-menu > li.ruby-menu-mega-blog > div, ul.ruby-menu > li.ruby-menu-mega-shop > div {
    border-top: none;
  }
  ul.ruby-menu > li > ul, ul.ruby-menu > li > ul > li > ul, ul.ruby-menu > li > ul > li > ul > li > ul {
    border-top: none;
  }
  ul.ruby-menu.ruby-menu-dividers > li, ul.ruby-menu.ruby-menu-dividers > li > a, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social > a, ul.ruby-menu.ruby-menu-dividers > li > a:hover, ul.ruby-menu.ruby-menu-dividers > li:hover > a {
    border: none;
  }
}
/* transision */
span.ruby-dropdown-toggle {
  transition: transform 0.3s ease;
}

span.ruby-dropdown-toggle:after {
  transition: transform 0.3s ease;
}

@media (min-width: 767px) {
  ul.ruby-menu > li > a:after {
    transition: all 0.3s ease;
  }
  ul.ruby-menu > li > ul > li > a:after, ul.ruby-menu > li > ul > li > ul > li > a:after, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:after {
    transition: all 0.3s ease;
  }
  ul.ruby-menu > li > ul, ul.ruby-menu > li > div {
    transform: translateY(25px);
    transition: all 0.3s ease;
  }
  ul.ruby-menu > li:hover > ul, ul.ruby-menu > li:hover > div {
    transform: translateY(0);
  }
  ul.ruby-menu.ruby-vertical > li > ul, ul.ruby-menu.ruby-vertical > li > div {
    transform: translateX(25px);
    transition: all 0.3s ease;
  }
  ul.ruby-menu.ruby-vertical > li:hover > ul, ul.ruby-menu.ruby-vertical > li:hover > div {
    transform: translateX(0);
  }
  ul.ruby-menu > li > ul > li > ul, ul.ruby-menu > li > ul > li > ul > li > ul, ul.ruby-menu > li > ul > li > ul > li > ul > li > ul {
    transform: translateX(25px);
    transition: all 0.3s ease;
  }
  ul.ruby-menu > li > ul > li:hover > ul, ul.ruby-menu > li > ul > li > ul > li:hover > ul, ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > ul {
    transform: translateX(0);
  }
  ul.ruby-menu > li > ul > li.ruby-open-to-left > ul, ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left > ul, ul.ruby-menu > li > ul > li > ul > li > ul > li.ruby-open-to-left > ul {
    transform: translateX(-25px);
    transition: all 0.3s ease;
  }
  ul.ruby-menu > li > ul > li.ruby-open-to-left:hover > ul, ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left:hover > ul, ul.ruby-menu > li > ul > li > ul > li > ul > li.ruby-open-to-left:hover > ul {
    transform: translateX(0);
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {
    transform: translateY(-50px);
    transition: all 0.5s ease;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog:hover > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > div, ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > div {
    transform: translateY(0);
  }
  ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {
    transform: translateX(50px);
    transition: all 0.5s ease;
  }
  ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-blog:hover > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > div, ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > div {
    transform: translateX(0);
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div {
    transform: translateY(-50px);
    transition: all 0.5s ease;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop:hover > div > ul > li.ruby-active-menu-item > div, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > div {
    transform: translateY(0);
  }
  ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-shop > div > ul > li > div {
    transform: translateX(50px);
    transition: all 0.5s ease;
  }
  ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-shop:hover > div > ul > li.ruby-active-menu-item > div, ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-shop > div > ul > li:hover > div {
    transform: translateX(0);
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:after {
    transition: all 0.4s ease;
  }
}
/* main */
*, :before, :after {
  box-sizing: border-box;
}

body {
  font-family: "Open Sans", sans-serif;
}

div.ruby-wrapper {
  position: relative;
  width: 100%;
  height: 50px;
  margin: 0 auto;
  background: rgba(51, 51, 51, 0);
}

div.ruby-wrapper:hover {
  position: relative;
  width: 100%;
  height: 50px;
  margin: 0 auto;
  background: white;
  transition: 0.9s !important;
}

div.ruby-wrapper ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

div.ruby-wrapper > ul {
  position: relative;
}

ul.ruby-menu > li {
  float: left;
  font-size: 14px;
}

ul.ruby-menu > li.ruby-menu-right {
  float: right;
}

ul.ruby-menu > li > a {
  display: block;
  line-height: 50px;
  padding: 0 25px 0 15px;
  color: gray;
  text-decoration: none;
  font-family: "Open Sans", sans-serif;
  font-weight: 700;
  text-transform: uppercase;
}

ul.ruby-menu > li > a:only-child {
  padding: 0 15px;
}

ul.ruby-menu > li > a:hover, ul.ruby-menu > li:hover > a, ul.ruby-menu > li.ruby-active-menu-item > a:hover, ul.ruby-menu > li.ruby-active-menu-item:hover > a {
  background: rgba(25, 173, 133, 0);
}

ul.ruby-menu > li > a:only-child:after, ul.ruby-menu > li:hover > a:only-child:after {
  content: "";
}

ul.ruby-menu > li.ruby-active-menu-item > a {
  background: rgba(23, 164, 124, 0);
}

ul.ruby-menu > li > a .fa {
  position: relative;
  width: 24px;
}

ul.ruby-menu > li > a > img {
  display: block;
}

ul.ruby-menu > li.ruby-menu-social > a {
  padding: 0;
  width: 30px;
  padding: 0 8px;
  font-size: 16px;
}

ul.ruby-menu > li.ruby-menu-social > a > span {
  display: none;
}

ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social.ruby-menu-search > a {
  transition: all 0.5s ease;
  max-height: 50px;
  width: 30px;
  transition: all 0.5s ease;
  transition-delay: 0.3s;
}

ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a:hover, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social.ruby-menu-search > a:hover {
  width: 120px;
}

ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a:hover > span input, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social.ruby-menu-search > a:hover > span input {
  transform: scaleY(1);
  max-width: 80px;
}

ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a span, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social.ruby-menu-search > a span {
  display: inline;
}

ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a > span input, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social.ruby-menu-search > a > span input {
  position: absolute;
  width: 80px;
  height: 50px;
  line-height: 50px;
  margin: 0;
  background: none;
  color: #efefef;
  border: none;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 700;
  text-transform: uppercase;
  max-width: 0;
  transform: scaleY(0);
  transition: all 0.5s ease;
  transition-delay: 0.3s;
}

ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a > span input:focus {
  outline: none;
  color: #efefef;
}

ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a > span input::-webkit-input-placeholder {
  color: #efefef;
}

ul.ruby-menu.ruby-menu-dividers > li > a, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social > a {
  border-left: 1px solid #111;
  border-right: 1px solid #666;
}

ul.ruby-menu.ruby-menu-dividers > li:first-child > a, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social:last-child > a {
  border-left: none;
}

ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li > a {
  border: none;
  border-top: 1px solid #111;
  border-bottom: 1px solid #666;
}

ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li:first-child > a {
  border-top: none;
}

ul.ruby-menu.ruby-menu-dividers > li > a:hover, ul.ruby-menu.ruby-menu-dividers > li:hover > a {
  border-right: 1px solid #19ad86;
}

ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li > a:hover, ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li:hover > a {
  border-bottom: 1px solid #19ad86;
}

ul.ruby-menu.ruby-menu-dividers > li.ruby-active-menu-item > a {
  border-right: 1px solid #17a47d;
}

ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li.ruby-active-menu-item > a {
  border-bottom: 1px solid #17a47d;
}

ul.ruby-menu > li > ul, ul.ruby-menu > li > ul > li > ul, ul.ruby-menu > li > ul > li > ul > li > ul {
  position: absolute;
  box-shadow: 0 8px 24px -5px #ccc;
  border-top: 4px solid rgba(251, 251, 251, 0);
}

ul.ruby-menu > li > ul > li, ul.ruby-menu > li > ul > li > ul > li {
  position: relative;
}

ul.ruby-menu > li > ul > li > a, ul.ruby-menu > li > ul > li > ul > li > a, ul.ruby-menu > li > ul > li > ul > li > ul > li > a {
  display: block;
  width: 170px;
  line-height: 40px;
  padding: 0 35px 0 25px;
  background: #fff;
  color: #666;
  text-decoration: none;
  font-size: 14px;
}

ul.ruby-menu > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > a:hover, ul.ruby-menu > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > a:hover, ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {
  background: #efefef;
}

ul.ruby-menu > li > ul > li > a:only-child:after, ul.ruby-menu > li > ul > li > ul > li > a:only-child:after, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:only-child:after {
  content: "";
}

ul.ruby-menu > li > ul > li > a .fa, ul.ruby-menu > li > ul > li > ul > li > a .fa, ul.ruby-menu > li > ul > li > ul > li > ul > li > a .fa {
  position: relative;
  width: 24px;
}

ul.ruby-menu > li.ruby-menu-right > ul {
  right: 0;
}

ul.ruby-menu > li > ul > li > ul, ul.ruby-menu > li > ul > li > ul > li > ul {
  left: 170px;
  top: -4px;
  z-index: 100;
}

ul.ruby-menu > li > ul > li.ruby-open-to-left > ul, ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left > ul {
  left: auto;
  right: 170px;
}

ul.ruby-menu > li.ruby-menu-mega > div, ul.ruby-menu > li.ruby-menu-mega-blog > div, ul.ruby-menu > li.ruby-menu-mega-shop > div {
  position: absolute;
  width: 100%;
  height: auto;
  left: 0;
  background: #fff;
  margin-top: 15px !important;
  border-top: 1px dashed gray;
  overflow: hidden;
  box-shadow: 0 8px 24px -5px #ccc;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav {
  position: relative;
  width: 200px;
  height: 100%;
  left: 0;
  top: 0;
  background: #efefef;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li {
  font-size: 14px;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a {
  display: block;
  line-height: 40px;
  padding: 0 15px;
  background: #efefef;
  color: #666;
  text-decoration: none;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a {
  background: #e6e6e6;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {
  position: absolute;
  width: 780px;
  height: auto;
  min-height: 100%;
  left: 200px;
  top: 0;
  background: #fff;
}

ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a {
  background: #ddd;
}

ul.ruby-menu > li.ruby-menu-mega-shop > div {
  text-align: center;
  z-index: 999999;
}

ul.ruby-menu > li.ruby-menu-mega-shop > div > ul {
  width: 100%;
  background: #efefef;
  margin: 0 auto;
  padding: 0;
  border-bottom: 1px solid #ddd;
  font-size: 0;
  z-index: 100;
}

ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li {
  display: inline-block;
  margin: 0;
}

ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {
  display: block;
  padding: 20px 15px;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 14px;
  font-stretch: expanded;
  color: #666;
}

ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > a, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a {
  text-decoration: none;
}

ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {
  position: relative;
  text-decoration: none;
  display: inline-block;
}

ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div {
  position: absolute;
  width: 100%;
  left: 0;
  top: auto;
  margin-top: 1px;
  text-align: left;
  background: #fff;
  z-index: -1;
}

div.ruby-grid, div.ruby-grid-lined {
  position: relative;
  width: 100%;
  padding: 0;
  margin: 0;
}

div.ruby-grid > div.ruby-row {
  position: relative;
  width: 100%;
  height: auto;
}

div.ruby-grid > div.ruby-row div.ruby-row [class^=ruby-col] {
  margin-top: 16px;
}

div.ruby-grid > div.ruby-row div.ruby-row:first-of-type [class^=ruby-col] {
  margin-top: 0;
}

div.ruby-grid.ruby-grid-lined > div.ruby-row:after {
  content: "";
  width: 100%;
  left: 0;
  bottom: 0;
  background: -webkit-linear-gradient(left, rgba(204, 204, 204, 0) 0%, rgba(204, 204, 204, 0.48) 24%, rgb(204, 204, 204) 50%, rgba(204, 204, 204, 0.42) 79%, rgba(204, 204, 204, 0) 100%);
}

div.ruby-grid.ruby-grid-lined > div.ruby-row:last-child:after {
  height: 0;
}

div.ruby-grid > div.ruby-row::after {
  content: "";
  display: table;
  clear: both;
}

div.ruby-grid > div.ruby-row [class^=ruby-col] {
  position: relative;
  float: left;
  height: auto;
}

div.ruby-grid > div.ruby-row > [class^=ruby-col] {
  padding: 16px;
}

div.ruby-grid > div.ruby-row > [class^=ruby-col] [class^=ruby-col] {
  padding-left: 16px;
}

div.ruby-grid > div.ruby-row > [class^=ruby-col] [class^=ruby-col]:first-of-type {
  padding-left: 0;
}

div.ruby-grid > div.ruby-row div.ruby-col-1 {
  width: 8.33%;
}

div.ruby-grid > div.ruby-row div.ruby-col-2 {
  width: 16.66%;
}

div.ruby-grid > div.ruby-row div.ruby-col-3 {
  width: 25%;
}

div.ruby-grid > div.ruby-row div.ruby-col-4 {
  width: 33.33%;
}

div.ruby-grid > div.ruby-row div.ruby-col-5 {
  width: 41.66%;
}

div.ruby-grid > div.ruby-row div.ruby-col-6 {
  width: 50%;
}

div.ruby-grid > div.ruby-row div.ruby-col-7 {
  width: 58.33%;
}

div.ruby-grid > div.ruby-row div.ruby-col-8 {
  width: 66.66%;
}

div.ruby-grid > div.ruby-row div.ruby-col-9 {
  width: 75%;
}

div.ruby-grid > div.ruby-row div.ruby-col-10 {
  width: 83.33%;
}

div.ruby-grid > div.ruby-row div.ruby-col-11 {
  width: 91.66%;
}

div.ruby-grid > div.ruby-row div.ruby-col-12 {
  width: 100%;
}

div.ruby-grid.ruby-grid-lined > div.ruby-row > div[class^=ruby-col]:after {
  content: "";
  position: absolute;
  top: 0;
  width: 1px;
  height: 100%;
  right: 0;
  background: -webkit-linear-gradient(top, rgba(204, 204, 204, 0) 0%, rgba(204, 204, 204, 0.48) 24%, rgb(204, 204, 204) 50%, rgba(204, 204, 204, 0.42) 79%, rgba(204, 204, 204, 0) 100%);
}

div.ruby-grid.ruby-grid-lined > div.ruby-row > div[class^=ruby-col]:last-child:after {
  width: 0;
}

div.ruby-grid img {
  position: relative;
  max-width: 100%;
  height: auto;
  display: block;
}

h3.ruby-list-heading {
  font-size: 14px;
  line-height: 24px;
  font-weight: 700;
  margin: 0;
}

ul.ruby-menu > li.ruby-menu-mega > div ul, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul {
  margin: 0;
  margin-top: 10px;
}

ul.ruby-menu > li.ruby-menu-mega > div ul li, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li {
  position: relative;
  font-size: 14px;
  line-height: 28px;
  display: block;
  width: 100%;
}

ul.ruby-menu > li.ruby-menu-mega > div ul li > a, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li > a {
  text-decoration: none;
  color: #555;
  display: inline-block;
}

ul.ruby-menu > li.ruby-menu-mega > div ul li > a:hover, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li > a:hover {
  color: #222;
  text-decoration: underline;
}

ul.ruby-menu > li.ruby-menu-mega > div ul li .fa, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li .fa {
  position: relative;
  width: 24px;
}

ul.ruby-menu > li.ruby-menu-mega > div ul.ruby-list-with-images li {
  height: 50px;
}

ul.ruby-menu > li.ruby-menu-mega > div ul.ruby-list-with-images li span.ruby-list-desc {
  font-size: 11px;
  display: block;
  position: absolute;
  top: 16px;
  left: 72px;
  color: #999;
}

ul.ruby-menu > li.ruby-menu-mega > div ul li > a > img {
  float: left;
  width: 60px;
  margin-right: 12px;
}

span.ruby-c-title, span.ruby-c-category, span.ruby-c-date {
  position: relative;
  display: block;
}

span.ruby-c-title a, span.ruby-c-category a, span.ruby-c-date a {
  text-decoration: none;
}

span.ruby-c-title, span.ruby-c-title a {
  font-size: 14px;
  font-weight: 700;
  text-transform: capitalize;
  line-height: 20px;
  margin-top: -5px;
  color: #222;
}

span.ruby-c-title a:hover {
  color: #444;
  text-decoration: underline;
}

span.ruby-c-category, span.ruby-c-category a {
  font-size: 11px;
  margin: 9px 0;
  color: #444;
}

span.ruby-c-date, span.ruby-c-date a {
  font-size: 11px;
  color: #444;
}

span.ruby-c-category a:hover, span.ruby-c-date a:hover {
  color: #19ad86;
}

div.ruby-c-inline {
  display: block;
  position: relative;
  height: 14px;
  margin: 7px 0;
}

div.ruby-c-inline span.ruby-c-category, div.ruby-c-inline span.ruby-c-date {
  position: absolute;
  display: inline-block;
}

div.ruby-c-inline span.ruby-c-date {
  right: 0;
}

div.ruby-c-inline span.ruby-c-category, div.ruby-c-inline span.ruby-c-category a {
  margin: 0;
}

span.ruby-c-content {
  display: block;
  position: relative;
  top: 7px;
  font-size: 12px;
  line-height: 18px;
  text-align: justify;
}

.ruby-wrapper .visible-xs {
  visibility: hidden;
  position: absolute;
}

@media (min-width: 768px) {
  div.ruby-wrapper.ruby-menu-transparent {
    background: none;
  }
  div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li.ruby-active-menu-item > a {
    background: none;
  }
  div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li.ruby-menu-social > a {
    border: none;
  }
  div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu.ruby-menu-dividers > li > a {
    border: none;
  }
  div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li:hover > a, div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li > a:hover, div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu.ruby-menu-dividers > li:hover > a, div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu.ruby-menu-dividers > li > a:hover {
    background: none;
    color: #e2e2e2;
  }
  div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a:hover, div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li.ruby-menu-social.ruby-menu-search:hover > a {
    background: none;
  }
  div.ruby-wrapper.ruby-menu-full-width {
    width: 100%;
  }
  div.ruby-wrapper.ruby-menu-full-width > ul.ruby-menu {
    width: 980px;
    margin: 0 auto;
  }
  ul.ruby-menu > li > ul, ul.ruby-menu > li > ul > li > ul, ul.ruby-menu > li > ul > li > ul > li > ul {
    visibility: hidden;
    opacity: 0;
  }
  ul.ruby-menu > li:hover > ul, ul.ruby-menu > li > ul > li:hover > ul, ul.ruby-menu > li > ul > li > ul > li:hover > ul {
    visibility: visible;
    opacity: 1;
  }
  ul.ruby-menu > li.ruby-menu-mega > div, ul.ruby-menu > li.ruby-menu-mega-blog > div, ul.ruby-menu > li.ruby-menu-mega-shop > div {
    visibility: hidden;
    opacity: 0;
  }
  ul.ruby-menu > li.ruby-menu-mega:hover > div, ul.ruby-menu > li.ruby-menu-mega-blog:hover > div, ul.ruby-menu > li.ruby-menu-mega-shop:hover > div {
    visibility: visible;
    opacity: 1;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {
    visibility: hidden;
    opacity: 0;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog:hover > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > div {
    visibility: visible;
    opacity: 1;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > div {
    visibility: visible;
    opacity: 1;
    z-index: 101;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div {
    visibility: hidden;
    opacity: 0;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop:hover > div > ul > li.ruby-active-menu-item > div, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > div {
    visibility: visible;
    opacity: 1;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:after {
    height: 1px;
    position: absolute;
    content: "";
    background-color: #19ad86;
    width: 0;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before {
    top: 10px;
    left: 5%;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:after {
    bottom: 10px;
    right: 5%;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover, .snip1217 .current a {
    color: #333;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover:before, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a:before, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover:after, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a:after, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > a:before, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > a:after {
    width: 90%;
  }
  ul.ruby-menu > li > a:after {
    font-family: "Font Awesome 5 Free";
    text-decoration: none;
    content: "\\f107";
    position: absolute;
    margin-left: 5px;
  }
  ul.ruby-menu > li:hover > a:after {
    transform: rotate(-180deg);
  }
  ul.ruby-menu > li > ul > li > a:after, ul.ruby-menu > li > ul > li > ul > li > a:after, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:after {
    font-family: "FontAwesome";
    text-decoration: none;
    font-size: 16px;
    padding: 0;
    content: "\\f105";
    position: absolute;
    right: 15px;
  }
  ul.ruby-menu > li > ul > li:hover > a:after, ul.ruby-menu > li > ul > li > ul > li:hover > a:after, ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a:after {
    transform: rotate(-180deg);
  }
  ul.ruby-menu > li > ul > li.ruby-open-to-left > a:after, ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left > a:after, ul.ruby-menu > li > ul > li > ul > li > ul > li.ruby-open-to-left > a:after {
    content: "\\f104";
    right: auto;
    left: 10px;
  }
  ul.ruby-menu > li > ul > li.ruby-open-to-left:hover > a:after, ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left:hover > a:after, ul.ruby-menu > li > ul > li > ul > li > ul > li.ruby-open-to-left:hover > a:after {
    transform: rotate(-180deg);
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a:after, ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a:after {
    content: "";
    position: absolute;
    right: 0;
    margin-top: 13px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 6px 8px 6px 0;
    border-color: transparent #fff transparent transparent;
  }
}
/* responsive */
@media (max-width: 767px) {
  .menu-mob {
    display: block;
    background-color: white;
  }
  .menu_active {
    display: none;
  }
  div.ruby-wrapper .hidden-xs {
    visibility: hidden;
    display: none;
  }
  div.ruby-wrapper {
    position: absolute;
    width: 100%;
    top: 0;
    background: #111;
  }
  .ruby-wrapper .visible-xs {
    visibility: visible;
    position: absolute;
    left: 0;
    top: 0;
  }
  div.ruby-wrapper > ul {
    position: absolute;
    top: 50px;
    width: 100%;
  }
  ul.ruby-menu > li, ul.ruby-menu > li.ruby-menu-right {
    float: none;
  }
  ul.ruby-menu > li > a {
    padding: 0 65px;
    background: #19ad86;
  }
  ul.ruby-menu > li > a:only-child {
    padding: 0 65px;
  }
  ul.ruby-menu > li > a:hover, ul.ruby-menu > li:hover > a, ul.ruby-menu > li.ruby-active-menu-item > a:hover {
    background: #127e61;
  }
  ul.ruby-menu > li.ruby-active-menu-item > a {
    background: #159572;
  }
  ul.ruby-menu > li.ruby-menu-social > a > span {
    display: block;
  }
  ul.ruby-menu > li > ul, ul.ruby-menu > li > ul > li > ul, ul.ruby-menu > li > ul > li > ul > li > ul {
    position: relative;
    width: 100%;
    box-shadow: none;
    border-top: none;
  }
  ul.ruby-menu > li, ul.ruby-menu > li > ul > li, ul.ruby-menu > li > ul > li > ul > li, ul.ruby-menu > li > ul > li > ul > li > ul > li {
    position: relative;
  }
  ul.ruby-menu > li > ul > li > a, ul.ruby-menu > li > ul > li > ul > li > a, ul.ruby-menu > li > ul > li > ul > li > ul > li > a {
    width: 100%;
    line-height: 50px;
    padding: 0 80px;
    background: #d1d1d1;
  }
  ul.ruby-menu > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > a:hover, ul.ruby-menu > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > a:hover, ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {
    background: #d9d9d9;
    color: #111;
  }
  ul.ruby-menu > li > ul > li > ul, ul.ruby-menu > li > ul > li > ul > li > ul {
    left: auto;
    top: auto;
    z-index: auto;
  }
  ul.ruby-menu > li > ul > li.ruby-open-to-left > ul, ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left > ul {
    left: auto;
    right: auto;
  }
  ul.ruby-menu > li > ul > li > ul > li > a {
    background: #e5e5e5;
    padding: 0 95px;
  }
  ul.ruby-menu > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > a:hover {
    background: #e1e1e1;
  }
  ul.ruby-menu > li > ul > li > ul > li > ul > li > a {
    background: #efefef;
    padding: 0 110px;
  }
  ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {
    background: #fff;
  }
  ul.ruby-menu > li.ruby-menu-social > a {
    border: none;
  }
  ul.ruby-menu > li.ruby-menu-mega, ul.ruby-menu > li.ruby-menu-mega-blog, ul.ruby-menu > li.ruby-menu-mega-shop {
    position: relative;
  }
  ul.ruby-menu > li.ruby-menu-mega > div, ul.ruby-menu > li.ruby-menu-mega-blog > div, ul.ruby-menu > li.ruby-menu-mega-shop > div {
    position: relative;
    top: auto;
    left: auto;
    border-top: none;
    box-shadow: none;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav {
    width: 100%;
    height: auto;
    left: auto;
    top: auto;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li {
    position: relative;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a {
    line-height: 50px;
    padding: 0 75px;
    background: #d1d1d1;
    color: #222;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a {
    background: #bcbcbc;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {
    position: relative;
    width: 100%;
    min-height: auto;
    left: auto;
    top: auto;
    z-index: auto;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a {
    background: #d9d9d9;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div {
    position: relative;
    text-align: left;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul {
    position: relative;
    border: none;
    font-size: 14px;
    margin-bottom: -1px;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li {
    position: relative;
    display: block;
    margin-top: -1px;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {
    padding: 0 80px;
    line-height: 50px;
    max-height: 50px;
    text-transform: none;
    font-weight: 400;
    background: #d1d1d1;
    color: #222;
    border: none;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a {
    background: #bcbcbc;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > a, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a {
    background: #d9d9d9;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {
    display: block;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div {
    position: relative;
    top: 0;
    z-index: 9999;
    margin: 0;
  }
  ul.ruby-menu > li.ruby-menu-social img {
    display: inline-table;
    position: absolute;
    top: 15px;
  }
  ul.ruby-menu > li.ruby-menu-social > a {
    width: 100%;
  }
  ul.ruby-menu > li.ruby-menu-social .fa {
    position: absolute;
    top: 17px;
  }
  ul.ruby-menu > li.ruby-menu-social span {
    line-height: 50px;
    padding: 0 25px;
  }
  span.ruby-dropdown-toggle {
    position: absolute;
    width: 50px;
    height: 50px;
    max-width: 50px;
    max-height: 50px;
    left: 0;
    top: 0;
    padding: 10px 17px;
    z-index: 1000000;
    cursor: pointer;
  }
  span.ruby-dropdown-toggle:after {
    font-family: "FontAwesome";
    text-decoration: none;
    content: "\\f107";
    color: #fff;
    font-size: 25px;
    right: 0;
  }
  span.ruby-dropdown-toggle.ruby-dropdown-toggle-rotate {
    transform: rotate(180deg);
  }
  ul.ruby-menu > li > a:before, ul.ruby-menu > li > ul > li > a:before, ul.ruby-menu > li > ul > li > ul > li > a:before, ul.ruby-menu > li > ul > li > ul > li > ul > li > a:before, ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a:before, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before {
    content: "";
    width: 50px;
    height: 50px;
    background: #333;
    position: absolute;
    left: 0;
    top: 0;
  }
  ul.ruby-menu > li > ul > li > a:before, ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a:before, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before {
    background: #555;
  }
  ul.ruby-menu > li > ul > li > ul > li > a:before {
    background: #777;
  }
  ul.ruby-menu > li > ul > li > ul > li > ul > li > a:before {
    background: #999;
  }
  ul.ruby-menu > li > ul > li > ul > li > ul, ul.ruby-menu > li > ul > li > ul, ul.ruby-menu > li > ul, ul.ruby-menu, ul.ruby-menu > li.ruby-menu-mega > div, ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div, ul.ruby-menu > li.ruby-menu-mega-blog > div, ul.ruby-menu > li.ruby-menu-mega-shop > div {
    max-height: 0;
    transform: scaleY(0);
    overflow: hidden;
  }
  ul.ruby-menu > li > ul.ruby-mobile-sublevel-show, ul.ruby-menu > li > ul > li > ul.ruby-mobile-sublevel-show, ul.ruby-menu > li > ul > li > ul > li > ul.ruby-mobile-sublevel-show, ul.ruby-menu.ruby-mobile-sublevel-show, ul.ruby-menu > li.ruby-menu-mega > div.ruby-mobile-sublevel-show, ul.ruby-menu > li.ruby-menu-mega-blog > div.ruby-mobile-sublevel-show, ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div.ruby-mobile-sublevel-show, ul.ruby-menu > li.ruby-menu-mega-shop > div.ruby-mobile-sublevel-show, ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div.ruby-mobile-sublevel-show {
    max-height: 20000px;
    transform: scaleY(1);
  }
  div.ruby-grid > div.ruby-row div.ruby-row [class^=ruby-col] {
    margin-top: 0;
  }
  div.ruby-grid > div.ruby-row div.ruby-row:first-of-type [class^=ruby-col] {
    margin-top: 0;
  }
  div.ruby-grid.ruby-grid-lined > div.ruby-row:after {
    height: 0;
  }
  div.ruby-grid > div.ruby-row > [class^=ruby-col] {
    padding: 0;
  }
  div.ruby-grid > div.ruby-row > [class^=ruby-col] [class^=ruby-col] {
    padding-left: 0;
  }
  div.ruby-grid > div.ruby-row > [class^=ruby-col] [class^=ruby-col]:first-of-type {
    padding-left: 0;
  }
  div.ruby-grid > div.ruby-row div.ruby-col-1, div.ruby-grid > div.ruby-row div.ruby-col-2, div.ruby-grid > div.ruby-row div.ruby-col-3, div.ruby-grid > div.ruby-row div.ruby-col-4, div.ruby-grid > div.ruby-row div.ruby-col-5, div.ruby-grid > div.ruby-row div.ruby-col-6, div.ruby-grid > div.ruby-row div.ruby-col-7, div.ruby-grid > div.ruby-row div.ruby-col-8, div.ruby-grid > div.ruby-row div.ruby-col-9, div.ruby-grid > div.ruby-row div.ruby-col-10, div.ruby-grid > div.ruby-row div.ruby-col-11, div.ruby-grid > div.ruby-row div.ruby-col-12 {
    width: 100%;
    padding: 20px 30px;
  }
  div.ruby-grid.ruby-grid-lined > div.ruby-row > div[class^=ruby-col]:after {
    width: 0;
  }
  div.ruby-grid img {
    position: relative;
    max-width: 100%;
    height: auto;
    display: block;
  }
  div.ruby-grid > div.ruby-row::after {
    content: "";
    display: table;
    clear: both;
  }
  .c-hamburger {
    display: block;
    position: relative;
    overflow: hidden;
    margin: 0;
    padding: 0;
    width: 50px;
    height: 50px;
    font-size: 0;
    text-indent: -9999px;
    appearance: none;
    box-shadow: none;
    border-radius: none;
    border: none;
    cursor: pointer;
    transition: background 0.3s;
  }
  .c-hamburger:focus {
    outline: none;
  }
  .c-hamburger span {
    display: block;
    position: absolute;
    top: 24px;
    left: 8px;
    right: 8px;
    height: 3px;
    background: #fff;
  }
  .c-hamburger span::before, .c-hamburger span::after {
    position: absolute;
    display: block;
    left: 0;
    width: 100%;
    height: 3px;
    background-color: #fff;
    content: "";
  }
  .c-hamburger span::before {
    top: -10px;
  }
  .c-hamburger span::after {
    bottom: -10px;
  }
  .c-hamburger--htx {
    background-color: #19ad86;
  }
  .c-hamburger--htx span {
    transition: background 0 0.3s;
  }
  .c-hamburger--htx span::before, .c-hamburger--htx span::after {
    transition-duration: 0.3s, 0.3s;
    transition-delay: 0.3s, 0;
  }
  .c-hamburger--htx span::before {
    transition-property: top, transform;
  }
  .c-hamburger--htx span::after {
    transition-property: bottom, transform;
  }
  .c-hamburger--htx.is-active {
    background-color: #333;
  }
  .c-hamburger--htx.is-active span {
    background: none;
  }
  .c-hamburger--htx.is-active span::before {
    top: 0;
    transform: rotate(45deg);
  }
  .c-hamburger--htx.is-active span::after {
    bottom: 0;
    transform: rotate(-45deg);
  }
  .c-hamburger--htx.is-active span::before, .c-hamburger--htx.is-active span::after {
    transition-delay: 0s, 0.3s;
  }
  ul.ruby-menu.ruby-menu-dividers > li, ul.ruby-menu.ruby-menu-dividers > li > a, ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social > a, ul.ruby-menu.ruby-menu-dividers > li > a:hover, ul.ruby-menu.ruby-menu-dividers > li:hover > a {
    border: none;
  }
  div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li.ruby-active-menu-item > a {
    padding-left: 45px;
  }
  ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a {
    display: none;
  }
}
@media (min-width: 768px) and (max-width: 991px) {
  .ruby-wrapper .hidden-md {
    visibility: hidden;
    display: none;
  }
  div.ruby-wrapper {
    width: 760px;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav {
    width: 170px;
  }
  ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {
    width: 590px;
    left: 170px;
  }
  ul.ruby-menu.ruby-vertical > li.ruby-menu-mega > div, ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-blog > div, ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-shop > div {
    width: 560px;
  }
  ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {
    width: 360px;
  }
  span.ruby-c-date {
    display: none;
    visibility: hidden;
    opacity: 0;
  }
  div.ruby-grid > div.ruby-row div.ruby-col-3-md {
    width: 25%;
  }
  div.ruby-grid > div.ruby-row div.ruby-col-4-md {
    width: 33.33%;
  }
  div.ruby-grid > div.ruby-row div.ruby-col-6-md {
    width: 50%;
  }
  div.ruby-grid > div.ruby-row div.ruby-col-12-md {
    width: 100%;
  }
  div.ruby-grid.ruby-grid-lined > div.ruby-row:after, div.ruby-grid.ruby-grid-lined > div.ruby-row > div[class^=ruby-col]:after {
    background: none;
  }
  ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {
    padding: 20px 5px;
    font-size: 12px;
    font-stretch: condensed;
    color: #666;
  }
}`, "",{"version":3,"sources":["webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_animation.scss","webpack://./src/Pages/PublicPages/Homepage/NavbarLanding/NavbarLanding.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_sidebar.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/variables.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_menu.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_popperArrow.scss","webpack://./node_modules/react-pro-sidebar/dist/scss/partials/_reactSlidedown.scss","webpack://./src/Assets/Scss/veriables.scss"],"names":[],"mappings":"AAAA;EACE;IAKE,uBAAA;ECDF;EDIA;IACE,wBAAA;ECFF;EDKA;IACE,yBAAA;ECHF;EDMA;IACE,uBAAA;ECJF;EDOA;IACE,wBAAA;ECLF;AACF;ACQA;EACE,cC1Bc;ED2Bd,YAAA;EACA,YC3Bc;ED4Bd,gBC5Bc;ED6Bd,gBAAA;EACA,oCAAA;EACA,kBAAA;EACA,aAAA;ADNF;ACOE;EACE,mBCpCe;EDqCf,YAAA;EACA,kBAAA;EACA,YAAA;ADLJ;ACOI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;ADLN;ACQI;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;ADNN;ACQM;EACE,iDAAA;ADNR;ACQM;EACE,YAAA;ADNR;ACQM;EACE,8CAAA;ADNR;ACQM;EACE,qBAAA;EACA,UAAA;EACA,SAAA;ADNR;ACWE;EACE,eAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,oCAAA;EACA,YAAA;EACA,aAAA;ADTJ;ACYE;EACE,WCxFsB;EDyFtB,eCzFsB;AF+E1B;ACaE;EACE,iBAAA;EACA,cAAA;ADXJ;ACeI;EADF;IAnGA,eAAA;IACA,YAAA;EDyFA;ECxFA;IACE,WAAA;ED0FF;ECxFA;IACE,OAAA;ED0FF;ECzFE;IACE,cAAA;ED2FJ;ECxFA;IACE,UAAA;IACA,aAAA;ED0FF;ECzFE;IACE,UAAA;IACA,YAAA;ED2FJ;ECzFE;IACE,UAAA;IACA,QAAA;ED2FJ;AACF;ACPI;EADF;IAxGA,eAAA;IACA,YAAA;EDoHA;ECnHA;IACE,WAAA;EDqHF;ECnHA;IACE,OAAA;EDqHF;ECpHE;IACE,cAAA;EDsHJ;ECnHA;IACE,UAAA;IACA,aAAA;EDqHF;ECpHE;IACE,UAAA;IACA,YAAA;EDsHJ;ECpHE;IACE,UAAA;IACA,QAAA;EDsHJ;AACF;AC7BI;EADF;IA7GA,eAAA;IACA,YAAA;ED+IA;EC9IA;IACE,WAAA;EDgJF;EC9IA;IACE,OAAA;EDgJF;EC/IE;IACE,cAAA;EDiJJ;EC9IA;IACE,UAAA;IACA,aAAA;EDgJF;EC/IE;IACE,UAAA;IACA,YAAA;EDiJJ;EC/IE;IACE,UAAA;IACA,QAAA;EDiJJ;AACF;ACnDI;EADF;IAlHA,eAAA;IACA,YAAA;ED0KA;ECzKA;IACE,WAAA;ED2KF;ECzKA;IACE,OAAA;ED2KF;EC1KE;IACE,cAAA;ED4KJ;ECzKA;IACE,UAAA;IACA,aAAA;ED2KF;EC1KE;IACE,UAAA;IACA,YAAA;ED4KJ;EC1KE;IACE,UAAA;IACA,QAAA;ED4KJ;AACF;ACzEI;EADF;IAvHA,eAAA;IACA,YAAA;EDqMA;ECpMA;IACE,WAAA;EDsMF;ECpMA;IACE,OAAA;EDsMF;ECrME;IACE,cAAA;EDuMJ;ECpMA;IACE,UAAA;IACA,aAAA;EDsMF;ECrME;IACE,UAAA;IACA,YAAA;EDuMJ;ECrME;IACE,UAAA;IACA,QAAA;EDuMJ;AACF;AC/FI;EADF;IA5HA,eAAA;IACA,YAAA;EDgOA;EC/NA;IACE,WAAA;EDiOF;EC/NA;IACE,OAAA;EDiOF;EChOE;IACE,cAAA;EDkOJ;EC/NA;IACE,UAAA;IACA,aAAA;EDiOF;EChOE;IACE,UAAA;IACA,YAAA;EDkOJ;EChOE;IACE,UAAA;IACA,QAAA;EDkOJ;AACF;;AGvPE;EACE,WAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,gGAAA;AH0PJ;;AGrPA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AHwPF;;AGpPE;EACE,iBAAA;EACA,oBAAA;AHuPJ;AGnPQ;EACE,kBAAA;EACA,yBD1BS;AF+QnB;AGnPU;EACE,iBAAA;EACA,oBAAA;AHqPZ;AGhPI;EACE,qBAAA;EACA,cDzCU;AF2RhB;AGjPM;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,6BAAA;AHmPR;AGjPM;EACE,cDjDU;AFoSlB;AGhPI;EACE,eAAA;AHkPN;AGjPM;EACE,cDvDU;AF0SlB;AGhPM;EACE,UAAA;EACA,wBAAA;AHkPR;AGhPM;EACE,aAAA;EACA,iBAAA;EACA,UAAA;EACA,wBAAA;AHkPR;AG/OM;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,eAAA;AHiPR;AG/OQ;EACE,aAAA;EACA,cD9EQ;AF+TlB;AG/OQ;EACE,kBAAA;EACA,eAAA;EACA,WD/EE;ECgFF,eDhFE;ECiFF,YDjFE;ECkFF,iBDlFE;ECmFF,kBAAA;EACA,qBAAA;AHiPV;AG/OU;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AHiPZ;AG7OQ;EACE,YAAA;EACA,cAAA;AH+OV;AG1OQ;EACE,cD1GQ;AFsVlB;AG1OY;EACE,6CAAA;AH4Od;AGpOU;EACE,mBDzHI;AF+VhB;AGnOU;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;AHqOZ;AGnOY;EACE,qBAAA;EACA,mBAAA;EACA,qBDrIE;ECsIF,yBAAA;EACA,cAAA;EACA,sBAAA;EACA,0BAAA;EACA,yBAAA;AHqOd;AG9NY;EACE,kCAAA;AHgOd;AG7Nc;EACE,wBAAA;AH+NhB;AGzNQ;EACE,kBDrJO;AFgXjB;AGzNU;EACE,0BAAA;AH2NZ;AGzNY;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;EACA,iBAAA;AH2Nd;AGnNM;EACE,aAAA;AHqNR;AGzMU;EACE,yBDvLI;AFkYhB;AGlMU;EACE,gBAAA;AHoMZ;AG5LU;EACE,kBAAA;AH8LZ;AGtLU;EACE,kBAAA;AHwLZ;AG5KQ;EAWE,kBAAA;AHoKV;AG7KY;;EAEE,UAAA;AH+Kd;AG5KU;EACE,yBDxOiB;ECyOjB,YAAA;AH8KZ;AG3KU;EACE,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,eAAA;AH6KZ;AG3KU;EACE,kBAAA;AH6KZ;AG3KY;EACE,oBAAA;AH6Kd;AG3Kc;EACE,aAAA;AH6KhB;AG1KY;EACE,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;AH4Kd;AG3Kc;EACE,kBAAA;AH6KhB;AG3Kc;EACE,iBAAA;EACA,gBAAA;EACA,yBD/Qa;ECgRb,kBAAA;EACA,kBAAA;AH6KhB;AGzKc;EACE,sCAAA;EACA,mBAAA;AH2KhB;AGxKgB;EACE,6CAAA;AH0KlB;AGpKc;;EAEE,yBAAA;AHsKhB;AGzJQ;EACE,eAAA;EACA,gBAAA;AH2JV;AGzJQ;EACE,0BAAA;AH2JV;AG1JU;EACE,eAAA;EACA,iBAAA;AH4JZ;AGtJY;EACE,WAAA;EACA,UAAA;AHwJd;AGvJc;EACE,yBAAA;AHyJhB;AGlJgB;EACE,wBAAA;AHoJlB;AG9IU;EACE,eAAA;EACA,mBD/UK;AF+djB;AG9IY;EACE,0BAAA;AHgJd;AG/Ic;EACE,eAAA;EACA,iBAAA;AHiJhB;AGnIc;EACE,eAAA;EACA,kBAAA;AHqIhB;AGpIgB;EACE,mBAAA;AHsIlB;AGpIgB;EACE,eAAA;EACA,mBAAA;AHsIlB;AGjIgB;;EAEE,yBAAA;AHmIlB;;AI9fA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,iCAAA;EACA,oCAAA;AJigBF;;AI9fA;EACE,QAAA;EACA,+BAAA;AJigBF;;AI9fA;EACE,OAAA;EACA,8BAAA;AJigBF;;AKjhBA;EACE,SAAA;EACA,yBAAA;EACA,yBAAA;EACA,uCAAA;ALohBF;;AKjhBA;EACE,kBAAA;ALohBF;;AKjhBA;EACE,aAAA;ALohBF;;AA7hBA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;AAgiBJ;;AA7hBA;EAEI,aAAA;AA+hBJ;;AA3hBA;EAEI,eAAA;EACA,6BAAA;AA6hBJ;;AA1hBA;EAEI,uBAAA;EACA,2BAAA;EACA,6BAAA;EACA,+BAAA;EACA,gCAAA;AA4hBJ;;AAzhBA;EAEI,yBAAA;EACA,6BAAA;EACA,gCAAA;EACA,+BAAA;AA2hBJ;;AAxhBA;EAEI,yBAAA;EACA,eAAA;EACA,cM9BG;ANwjBP;;AAthBA;EAEI,uBAAA;EACA,gBAAA;AAwhBJ;;AArhBA;EAEI,2BAAA;EACA,4BAAA;AAuhBJ;;AAhhBA;EACI,cAAA;AAmhBJ;;AAhhBA;EACI,cAAA;AAmhBJ;;AAhhBA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;EACA,UAAA;AAmhBJ;;AAhhBA;EACI,gBAAA;EACA,WAAA;EACA,qBAAA;AAmhBJ;;AAhhBA;EACI,WAAA;AAmhBJ;;AAhhBA;EACI,YAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,oCAAA;EACA,eAAA;AAmhBJ;;AAhhBA;EACI,kBAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,cAAA;EACA,WAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,UAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,UAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,UAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,UAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,UAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,UAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,UAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,UAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,UAAA;EACA,kBAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;AAmhBJ;;AAhhBA;EACI,eAAA;EACA,iBAAA;EACA,WAAA;EACA,aAAA;AAmhBJ;;AAhhBA;EACI,iBAAA;AAmhBJ;;AAhhBA;EACI,UAAA;EACA,gBAAA;AAmhBJ;;AAhhBA;EACI,gBAAA;AAmhBJ;;AAhhBA;EACI,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,cAAA;EACA,SAAA;AAmhBJ;;AAhhBA;EACI,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,WAAA;EACA,SAAA;AAmhBJ;;AAhhBA;EACI,eAAA;EACA,iBAAA;EACA,WAAA;EACA,cAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,gBAAA;EACA,eAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,0BAAA;AAmhBJ;;AAhhBA;EACI,eAAA;EACA,gBAAA;EACA,YAAA;AAmhBJ;;AAhhBA;EACI,gBAAA;EACA,gBAAA;EACA,YAAA;AAmhBJ;;AAhhBA;EACI,eAAA;AAmhBJ;;AAhhBA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EACA,qBAAA;EACA,SAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;AAmhBJ;;AAhhBA;EACI,gBAAA;AAmhBJ;;AAhhBA;EACI,gBAAA;EACA,kBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;EACA,qBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;EACA,kBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;EACA,qBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;EACA,kBAAA;AAmhBJ;;AAhhBA;EACI,gBAAA;AAmhBJ;;AAhhBA;EACI,kBAAA;EACA,WAAA;EACA,SAAA;EACA,QAAA;AAmhBJ;;AAhhBA;EACI,eAAA;EACA,kBAAA;AAmhBJ;;AAhhBA;EACI,eAAA;EACA,cAAA;EACA,iBAAA;AAmhBJ;;AAhhBA;EACI,eAAA;EACA,WAAA;EACA,gBAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;EACA,yBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AAmhBJ;;AAhhBA;EACI,gBAAA;EACA,cAAA;AAmhBJ;;AAhhBA;EACI,mBAAA;EACA,sBAAA;EACA,aAAA;AAmhBJ;;AAhhBA;EACI,kBAAA;EACA,oBAAA;EACA,kBAAA;AAmhBJ;;AAhhBA;EACI,cAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,yBAAA;EAGA,iBAAA;AAmhBJ;;AAhhBA;EACI,YAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;EACA,sBAAA;EAKA,mBAAA;AAmhBJ;;AAhhBA;EACI,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AAmhBJ;;AAhhBA;EACI,UAAA;EACA,yBAAA;EAKA,mBAAA;EAIA,2BAAA;AAmhBJ;;AAhhBA;EACI,WAAA;EACA,sBAAA;EAKA,mBAAA;EAGA,wCAAA;EAIA,uBAAA;AAmhBJ;;AAhhBA;EACI,yBAAA;AAmhBJ;;AAhhBA;EACI,iBAAA;AAmhBJ;;AAhhBA;EACI,yBAAA;AAmhBJ;;AAhhBA;EACI,cAAA;AAmhBJ;;AAhhBA;EACI,gBAAA;EACA,YAAA;EACA,eAAA;AAmhBJ;;AAhhBA;EACI;IACI,kBAAA;EAmhBN;EAhhBE;IACI,kBAAA;IACA,YAAA;IACA,aAAA;IACA,cAAA;IACA,UAAA;EAkhBN;EA/gBE;IACI,gBAAA;IACA,WAAA;IACA,qBAAA;EAihBN;EA9gBE;IACI,YAAA;IACA,eAAA;EAghBN;EA7gBE;IACI,UAAA;EA+gBN;EA5gBE;IACI,UAAA;EA8gBN;EA3gBE;IACI,eAAA;IACA,YAAA;EA6gBN;EA1gBE;IACI,gBAAA;IACA,YAAA;EA4gBN;EAzgBE;IACI,WAAA;IACA,YAAA;IACA,sBAAA;EA2gBN;EAxgBE;IACI,gBAAA;IACA,YAAA;IACA,kBAAA;EA0gBN;AACF;AAvgBA;EACI;IACI,WAAA;IACA,YAAA;EAygBN;EAtgBE;IACI,WAAA;IACA,cAAA;IACA,oBAAA;IACA,aAAA;IACA,kBAAA;EAwgBN;EArgBE;IACI,WAAA;IACA,gBAAA;EAugBN;EApgBE;IACI,kBAAA;IACA,WAAA;IACA,SAAA;IACA,WAAA;IACA,UAAA;EAsgBN;EAngBE;IACI,eAAA;IACA,iBAAA;EAqgBN;EAlgBE;IACI,eAAA;EAogBN;EAjgBE;IACI,kBAAA;IACA,eAAA;IACA,yBAAA;EAmgBN;EAhgBE;IACI,aAAA;EAkgBN;EA/fE;IACI,WAAA;IACA,eAAA;IACA,aAAA;IACA,qBAAA;EAigBN;EA9fE;IACI,WAAA;EAggBN;EA7fE;IACI,WAAA;EA+fN;EA5fE;IACI,WAAA;EA8fN;EA3fE;IACI,WAAA;EA6fN;EA1fE;IACI,WAAA;EA4fN;EAzfE;IACI,WAAA;IACA,gBAAA;EA2fN;EAxfE;IACI,WAAA;IACA,UAAA;IACA,kBAAA;EA0fN;EAvfE;IACI,mBAAA;EAyfN;EAtfE;IACI,gBAAA;IACA,WAAA;IACA,oBAAA;EAwfN;AACF;AApfA,UAAA;AAEA;EACI,mBAAA;EACA,WAAA;AAqfJ;;AAlfA;EACI,WAAA;AAqfJ;;AAlfA;EACI,gBAAA;EACA,cAAA;AAqfJ;;AAlfA;EACI,mBAAA;EACA,WAAA;AAqfJ;;AAlfA;EACI,2BAAA;EACA,4BAAA;AAqfJ;;AAlfA;EACI,iBAAA;AAqfJ;;AAlfA;EACI,YAAA;EACA,0BAAA;EACA,6BAAA;AAqfJ;;AAlfA;EACI,gBAAA;AAqfJ;;AAlfA;EACI,2BAAA;EACA,4BAAA;AAqfJ;;AAlfA;EACI,6BAAA;AAqfJ;;AAlfA;EACI,8BAAA;EACA,4BAAA;AAqfJ;;AAlfA;EACI,6BAAA;EACA,iBAAA;EACA,kBAAA;AAqfJ;;AAlfA;EACI,iBAAA;EACA,kBAAA;AAqfJ;;AAlfA;EACI,6BAAA;EACA,iBAAA;AAqfJ;;AAlfA;EACI,0BAAA;AAqfJ;;AAlfA;EACI,gBAAA;EACA,WAAA;AAqfJ;;AAlfA;EACI,mBAAA;AAqfJ;;AAlfA;EACI,gBAAA;EACA,0BAAA;AAqfJ;;AAlfA;EACI,mBAAA;AAqfJ;;AAlfA;EACI,mBAAA;EACA,WAAA;AAqfJ;;AAlfA;EACI,mBAAA;AAqfJ;;AAlfA;EACI,gBAAA;AAqfJ;;AAlfA;EACI,gBAAA;AAqfJ;;AAlfA;EACI,mBAAA;EACA,6BAAA;AAqfJ;;AAlfA;EACI,WAAA;AAqfJ;;AAlfA;EACI,gBAAA;AAqfJ;;AAlfA;EACI,WAAA;AAqfJ;;AAlfA;EACI,WAAA;AAqfJ;;AAlfA;EACI,WAAA;AAqfJ;;AAlfA;EACI,WAAA;AAqfJ;;AAlfA;EACI,WAAA;AAqfJ;;AAlfA;EACI,WAAA;AAqfJ;;AAlfA;EACI;IACI,sBAAA;EAqfN;EAlfE;IACI,WAAA;EAofN;EAjfE;IACI,sDAAA;EAmfN;AACF;AAhfA;EACI;IACI,mBAAA;EAkfN;EA/eE;IACI,gBAAA;IACA,WAAA;EAifN;EA9eE;IACI,gBAAA;EAgfN;EA7eE;IACI,mBAAA;EA+eN;EA5eE;IACI,mBAAA;IACA,WAAA;EA8eN;EA3eE;IACI,mBAAA;EA6eN;EA1eE;IACI,mBAAA;EA4eN;EAzeE;IACI,mBAAA;EA2eN;EAxeE;IACI,gBAAA;EA0eN;EAveE;IACI,mBAAA;EAyeN;EAteE;IACI,mBAAA;EAweN;EAreE;IACI,mBAAA;EAueN;EApeE;IACI,mBAAA;EAseN;EAneE;IACI,WAAA;EAqeN;EAleE;IACI,gBAAA;EAoeN;EAjeE;IACI,gBAAA;EAmeN;EAheE;IACI,gBAAA;EAkeN;EA/dE;IACI,gBAAA;EAieN;EA9dE;IACI,gBAAA;EAgeN;EA7dE;IACI,sBAAA;EA+dN;EA5dE;IACI,yBAAA;IACA,WAAA;EA8dN;EA3dE;IACI,sBAAA;EA6dN;EA1dE;IACI,gBAAA;EA4dN;EAzdE;IACI,gBAAA;EA2dN;EAxdE;IACI,YAAA;EA0dN;AACF;AAvdA,eAAA;AAEA;EACI,+BAAA;AAwdJ;;AArdA;EACI,+BAAA;AAwdJ;;AArdA;EACI;IACI,yBAAA;EAwdN;EArdE;IACI,yBAAA;EAudN;EApdE;IACI,2BAAA;IACA,yBAAA;EAsdN;EAndE;IACI,wBAAA;EAqdN;EAldE;IACI,2BAAA;IACA,yBAAA;EAodN;EAjdE;IACI,wBAAA;EAmdN;EAhdE;IACI,2BAAA;IACA,yBAAA;EAkdN;EA/cE;IACI,wBAAA;EAidN;EA9cE;IACI,4BAAA;IACA,yBAAA;EAgdN;EA7cE;IACI,wBAAA;EA+cN;EA5cE;IACI,4BAAA;IACA,yBAAA;EA8cN;EA3cE;IACI,wBAAA;EA6cN;EA1cE;IACI,2BAAA;IACA,yBAAA;EA4cN;EAzcE;IACI,wBAAA;EA2cN;EAxcE;IACI,4BAAA;IACA,yBAAA;EA0cN;EAvcE;IACI,wBAAA;EAycN;EAtcE;IACI,2BAAA;IACA,yBAAA;EAwcN;EArcE;IACI,wBAAA;EAucN;EApcE;IAEI,yBAAA;EAscN;AACF;AAncA,SAAA;AAEA;EAGI,sBAAA;AAocJ;;AAjcA;EACI,oCAAA;AAocJ;;AAjcA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,+BAAA;AAocJ;;AAjcA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,iBAAA;EACA,2BAAA;AAocJ;;AAjcA;EACI,SAAA;EACA,UAAA;EACA,gBAAA;AAocJ;;AAjcA;EACI,kBAAA;AAocJ;;AAjcA;EACI,WAAA;EACA,eAAA;AAocJ;;AAjcA;EACI,YAAA;AAocJ;;AAjcA;EACI,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,qBAAA;EACA,oCAAA;EACA,gBAAA;EACA,yBAAA;AAocJ;;AAjcA;EACI,eAAA;AAocJ;;AAjcA;EACI,iCAAA;AAocJ;;AAhcA;EACI,WAAA;AAmcJ;;AAhcA;EACI,iCAAA;AAmcJ;;AAhcA;EACI,kBAAA;EACA,WAAA;AAmcJ;;AAhcA;EAEI,cAAA;AAkcJ;;AA/bA;EACI,UAAA;EACA,WAAA;EACA,cAAA;EACA,eAAA;AAkcJ;;AA/bA;EACI,aAAA;AAkcJ;;AA/bA;EACI,yBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,sBAAA;AAkcJ;;AA/bA;EACI,YAAA;AAkcJ;;AA/bA;EACI,oBAAA;EACA,eAAA;AAkcJ;;AA/bA;EACI,eAAA;AAkcJ;;AA/bA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,oCAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,sBAAA;AAkcJ;;AA/bA;EACI,aAAA;EACA,cAAA;AAkcJ;;AA/bA;EACI,cAAA;AAkcJ;;AA/bA;EACI,2BAAA;EACA,4BAAA;AAkcJ;;AA/bA;EACI,iBAAA;AAkcJ;;AA/bA;EACI,YAAA;EACA,0BAAA;EACA,6BAAA;AAkcJ;;AA/bA;EACI,gBAAA;AAkcJ;;AA/bA;EACI,+BAAA;AAkcJ;;AA/bA;EACI,gCAAA;AAkcJ;;AA/bA;EACI,+BAAA;AAkcJ;;AA/bA;EACI,gCAAA;AAkcJ;;AA/bA;EACI,kBAAA;EAGA,gCAAA;EACA,4CAAA;AAkcJ;;AA/bA;EACI,kBAAA;AAkcJ;;AA/bA;EACI,cAAA;EACA,YAAA;EACA,iBAAA;EACA,sBAAA;EACA,gBAAA;EACA,WAAA;EACA,qBAAA;EACA,eAAA;AAkcJ;;AA/bA;EACI,mBAAA;AAkcJ;;AA/bA;EACI,WAAA;AAkcJ;;AA/bA;EACI,kBAAA;EACA,WAAA;AAkcJ;;AA/bA;EACI,QAAA;AAkcJ;;AA/bA;EACI,WAAA;EACA,SAAA;EACA,YAAA;AAkcJ;;AA/bA;EACI,UAAA;EACA,YAAA;AAkcJ;;AA/bA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EAEA,gBAAA;EACA,2BAAA;EACA,2BAAA;EACA,gBAAA;EAGA,gCAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;EACA,MAAA;EACA,mBAAA;AAicJ;;AA9bA;EACI,eAAA;AAicJ;;AA9bA;EACI,cAAA;EACA,iBAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;AAicJ;;AA9bA;EACI,mBAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,YAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,MAAA;EACA,gBAAA;AAicJ;;AA9bA;EACI,gBAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,eAAA;AAicJ;;AA9bA;EACI,WAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,6BAAA;EACA,YAAA;EACA,YAAA;AAicJ;;AA9bA;EACI,qBAAA;EACA,SAAA;AAicJ;;AA9bA;EACI,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,WAAA;AAicJ;;AA9bA;EACI,qBAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,qBAAA;EACA,qBAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,WAAA;EACA,UAAA;EACA,SAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAicJ;;AA9bA;EACI,gBAAA;AAicJ;;AA9bA;EACI,aAAA;AAicJ;;AA9bA;EACI,WAAA;EACA,WAAA;EACA,OAAA;EACA,SAAA;EACA,uLAAA;AAicJ;;AA9bA;EACI,SAAA;AAicJ;;AA9bA;EACI,WAAA;EACA,cAAA;EACA,WAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,WAAA;EACA,YAAA;AAicJ;;AA9bA;EACI,aAAA;AAicJ;;AA9bA;EACI,kBAAA;AAicJ;;AA9bA;EACI,eAAA;AAicJ;;AA9bA;EACI,YAAA;AAicJ;;AA9bA;EACI,aAAA;AAicJ;;AA9bA;EACI,UAAA;AAicJ;;AA9bA;EACI,aAAA;AAicJ;;AA9bA;EACI,aAAA;AAicJ;;AA9bA;EACI,UAAA;AAicJ;;AA9bA;EACI,aAAA;AAicJ;;AA9bA;EACI,aAAA;AAicJ;;AA9bA;EACI,UAAA;AAicJ;;AA9bA;EACI,aAAA;AAicJ;;AA9bA;EACI,aAAA;AAicJ;;AA9bA;EACI,WAAA;AAicJ;;AA9bA;EACI,WAAA;EACA,kBAAA;EACA,MAAA;EACA,UAAA;EACA,YAAA;EACA,QAAA;EACA,sLAAA;AAicJ;;AA9bA;EACI,QAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;EACA,cAAA;AAicJ;;AA9bA;EACI,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,SAAA;AAicJ;;AA9bA;EACI,SAAA;EACA,gBAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,WAAA;AAicJ;;AA9bA;EACI,qBAAA;EACA,WAAA;EACA,qBAAA;AAicJ;;AA9bA;EACI,WAAA;EACA,0BAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,WAAA;AAicJ;;AA9bA;EACI,YAAA;AAicJ;;AA9bA;EACI,eAAA;EACA,cAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;AAicJ;;AA9bA;EACI,WAAA;EACA,WAAA;EACA,kBAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,cAAA;AAicJ;;AA9bA;EACI,qBAAA;AAicJ;;AA9bA;EACI,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,iBAAA;EACA,gBAAA;EACA,WAAA;AAicJ;;AA9bA;EACI,WAAA;EACA,0BAAA;AAicJ;;AA9bA;EACI,eAAA;EACA,aAAA;EACA,WAAA;AAicJ;;AA9bA;EACI,eAAA;EACA,WAAA;AAicJ;;AA9bA;EACI,cAAA;AAicJ;;AA9bA;EACI,cAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,qBAAA;AAicJ;;AA9bA;EACI,QAAA;AAicJ;;AA9bA;EACI,SAAA;AAicJ;;AA9bA;EACI,cAAA;EACA,kBAAA;EACA,QAAA;EACA,eAAA;EACA,iBAAA;EACA,mBAAA;AAicJ;;AA9bA;EACI,kBAAA;EACA,kBAAA;AAicJ;;AA9bA;EACI;IACI,gBAAA;EAicN;EA9bE;IACI,gBAAA;EAgcN;EA7bE;IACI,YAAA;EA+bN;EA5bE;IACI,YAAA;EA8bN;EA3bE;IACI,gBAAA;IACA,cAAA;EA6bN;EA1bE;IACI,gBAAA;EA4bN;EAzbE;IACI,WAAA;EA2bN;EAxbE;IACI,YAAA;IACA,cAAA;EA0bN;EAvbE;IACI,kBAAA;IACA,UAAA;EAybN;EAtbE;IACI,mBAAA;IACA,UAAA;EAwbN;EArbE;IACI,kBAAA;IACA,UAAA;EAubN;EApbE;IACI,mBAAA;IACA,UAAA;EAsbN;EAnbE;IACI,kBAAA;IACA,UAAA;EAqbN;EAlbE;IACI,mBAAA;IACA,UAAA;EAobN;EAjbE;IACI,mBAAA;IACA,UAAA;IACA,YAAA;EAmbN;EAhbE;IACI,kBAAA;IACA,UAAA;EAkbN;EA/aE;IACI,mBAAA;IACA,UAAA;EAibN;EA9aE;IACI,WAAA;IACA,kBAAA;IACA,WAAA;IACA,yBAAA;IACA,QAAA;EAgbN;EA7aE;IACI,SAAA;IACA,QAAA;EA+aN;EA5aE;IACI,YAAA;IACA,SAAA;EA8aN;EA3aE;IACI,WAAA;EA6aN;EA1aE;IACI,UAAA;EA4aN;EAzaE;IACI,kCAAA;IACA,qBAAA;IACA,gBAAA;IACA,kBAAA;IACA,gBAAA;EA2aN;EAxaE;IAKI,0BAAA;EA0aN;EAvaE;IACI,0BAAA;IACA,qBAAA;IACA,eAAA;IACA,UAAA;IACA,gBAAA;IACA,kBAAA;IACA,WAAA;EAyaN;EAtaE;IAKI,0BAAA;EAwaN;EAraE;IACI,gBAAA;IACA,WAAA;IACA,UAAA;EAuaN;EApaE;IAKI,0BAAA;EAsaN;EAnaE;IACI,WAAA;IACA,kBAAA;IACA,QAAA;IACA,gBAAA;IACA,QAAA;IACA,SAAA;IACA,mBAAA;IACA,2BAAA;IACA,sDAAA;EAqaN;AACF;AAlaA,eAAA;AAEA;EACI;IAEI,cAAA;IACA,uBAAA;EAkaN;EAhaE;IAEI,aAAA;EAiaN;EA9ZE;IACI,kBAAA;IACA,aAAA;EAgaN;EA7ZE;IACI,kBAAA;IACA,WAAA;IACA,MAAA;IACA,gBAAA;EA+ZN;EA5ZE;IACI,mBAAA;IACA,kBAAA;IACA,OAAA;IACA,MAAA;EA8ZN;EA3ZE;IACI,kBAAA;IACA,SAAA;IACA,WAAA;EA6ZN;EA1ZE;IACI,WAAA;EA4ZN;EAzZE;IACI,eAAA;IACA,mBAAA;EA2ZN;EAxZE;IACI,eAAA;EA0ZN;EAvZE;IACI,mBAAA;EAyZN;EAtZE;IACI,mBAAA;EAwZN;EArZE;IACI,cAAA;EAuZN;EApZE;IACI,kBAAA;IACA,WAAA;IAGA,gBAAA;IACA,gBAAA;EAsZN;EAnZE;IACI,kBAAA;EAqZN;EAlZE;IACI,WAAA;IACA,iBAAA;IACA,eAAA;IACA,mBAAA;EAoZN;EAjZE;IACI,mBAAA;IACA,WAAA;EAmZN;EAhZE;IACI,UAAA;IACA,SAAA;IACA,aAAA;EAkZN;EA/YE;IACI,UAAA;IACA,WAAA;EAiZN;EA9YE;IACI,mBAAA;IACA,eAAA;EAgZN;EA7YE;IACI,mBAAA;EA+YN;EA5YE;IACI,mBAAA;IACA,gBAAA;EA8YN;EA3YE;IACI,gBAAA;EA6YN;EA1YE;IACI,YAAA;EA4YN;EAzYE;IACI,kBAAA;EA2YN;EAxYE;IACI,kBAAA;IACA,SAAA;IACA,UAAA;IACA,gBAAA;IAGA,gBAAA;EA0YN;EAvYE;IACI,WAAA;IACA,YAAA;IACA,UAAA;IACA,SAAA;EAyYN;EAtYE;IACI,kBAAA;EAwYN;EArYE;IACI,iBAAA;IACA,eAAA;IACA,mBAAA;IACA,WAAA;EAuYN;EApYE;IACI,mBAAA;EAsYN;EAnYE;IACI,kBAAA;IACA,WAAA;IACA,gBAAA;IACA,UAAA;IACA,SAAA;IACA,aAAA;EAqYN;EAlYE;IACI,mBAAA;EAoYN;EAjYE;IACI,kBAAA;IACA,gBAAA;EAmYN;EAhYE;IACI,kBAAA;IACA,YAAA;IACA,eAAA;IACA,mBAAA;EAkYN;EA/XE;IACI,kBAAA;IACA,cAAA;IACA,gBAAA;EAiYN;EA9XE;IACI,eAAA;IACA,iBAAA;IACA,gBAAA;IACA,oBAAA;IACA,gBAAA;IACA,mBAAA;IACA,WAAA;IACA,YAAA;EAgYN;EA7XE;IACI,mBAAA;EA+XN;EA5XE;IACI,mBAAA;EA8XN;EA3XE;IACI,cAAA;EA6XN;EA1XE;IACI,kBAAA;IACA,MAAA;IACA,aAAA;IACA,SAAA;EA4XN;EAzXE;IACI,qBAAA;IACA,kBAAA;IACA,SAAA;EA2XN;EAxXE;IACI,WAAA;EA0XN;EAvXE;IACI,kBAAA;IACA,SAAA;EAyXN;EAtXE;IACI,iBAAA;IACA,eAAA;EAwXN;EArXE;IACI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,eAAA;IACA,gBAAA;IACA,OAAA;IACA,MAAA;IACA,kBAAA;IACA,gBAAA;IACA,eAAA;EAuXN;EApXE;IACI,0BAAA;IACA,qBAAA;IACA,gBAAA;IACA,WAAA;IACA,eAAA;IACA,QAAA;EAsXN;EAnXE;IAKI,yBAAA;EAqXN;EAlXE;IACI,WAAA;IACA,WAAA;IACA,YAAA;IACA,gBAAA;IACA,kBAAA;IACA,OAAA;IACA,MAAA;EAoXN;EAjXE;IACI,gBAAA;EAmXN;EAhXE;IACI,gBAAA;EAkXN;EA/WE;IACI,gBAAA;EAiXN;EA9WE;IACI,aAAA;IACA,oBAAA;IACA,gBAAA;EAgXN;EA7WE;IACI,mBAAA;IACA,oBAAA;EA+WN;EA5WE;IACI,aAAA;EA8WN;EA3WE;IACI,aAAA;EA6WN;EA1WE;IACI,SAAA;EA4WN;EAzWE;IACI,UAAA;EA2WN;EAxWE;IACI,eAAA;EA0WN;EAvWE;IACI,eAAA;EAyWN;EAtWE;IACI,WAAA;IACA,kBAAA;EAwWN;EArWE;IACI,QAAA;EAuWN;EApWE;IACI,kBAAA;IACA,eAAA;IACA,YAAA;IACA,cAAA;EAsWN;EAnWE;IACI,WAAA;IACA,cAAA;IACA,WAAA;EAqWN;EAlWE;IACI,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,YAAA;IACA,oBAAA;IAGA,gBAAA;IACA,gBAAA;IACA,mBAAA;IACA,YAAA;IACA,eAAA;IAEA,2BAAA;EAoWN;EAjWE;IACI,aAAA;EAmWN;EAhWE;IACI,cAAA;IACA,kBAAA;IACA,SAAA;IACA,SAAA;IACA,UAAA;IACA,WAAA;IACA,gBAAA;EAkWN;EA/VE;IACI,kBAAA;IACA,cAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,sBAAA;IACA,WAAA;EAiWN;EA9VE;IACI,UAAA;EAgWN;EA7VE;IACI,aAAA;EA+VN;EA5VE;IACI,yBAAA;EA8VN;EA3VE;IAEI,6BAAA;EA6VN;EA1VE;IAEI,+BAAA;IAEA,yBAAA;EA4VN;EAzVE;IAEI,mCAAA;EA2VN;EAxVE;IAEI,sCAAA;EA0VN;EAvVE;IACI,sBAAA;EAyVN;EAtVE;IACI,gBAAA;EAwVN;EArVE;IACI,MAAA;IAGA,wBAAA;EAuVN;EApVE;IACI,SAAA;IAGA,yBAAA;EAsVN;EAnVE;IAEI,0BAAA;EAqVN;EAlVE;IACI,YAAA;EAoVN;EAjVE;IACI,kBAAA;EAmVN;EAhVE;IACI,aAAA;EAkVN;AACF;AA/UA;EACI;IACI,kBAAA;IACA,aAAA;EAiVN;EA9UE;IACI,YAAA;EAgVN;EA7UE;IACI,YAAA;EA+UN;EA5UE;IACI,YAAA;IACA,WAAA;EA8UN;EA3UE;IACI,YAAA;EA6UN;EA1UE;IACI,YAAA;EA4UN;EAzUE;IACI,aAAA;IACA,kBAAA;IACA,UAAA;EA2UN;EAxUE;IACI,UAAA;EA0UN;EAvUE;IACI,aAAA;EAyUN;EAtUE;IACI,UAAA;EAwUN;EArUE;IACI,WAAA;EAuUN;EApUE;IACI,gBAAA;EAsUN;EAnUE;IACI,iBAAA;IACA,eAAA;IACA,uBAAA;IACA,WAAA;EAqUN;AACF","sourcesContent":["@keyframes swing {\n  0%,\n  30%,\n  50%,\n  70%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n  10% {\n    transform: rotate(10deg);\n  }\n\n  40% {\n    transform: rotate(-10deg);\n  }\n\n  60% {\n    transform: rotate(5deg);\n  }\n\n  80% {\n    transform: rotate(-5deg);\n  }\n}\n","@import \"../../../../Assets/Scss/veriables.scss\";\n@import \"~react-pro-sidebar/dist/scss/styles.scss\";\n\ndiv.ruby-menu-demo-header {\n    position: relative;\n    left: 0;\n    top: 0;\n    width: 100%;\n    height: auto;\n    padding: 0;\n    margin: 0;\n    z-index: 99999\n}\n\n.menu-mob\n{\n    display: none;\n    \n}\n\n.padding_set_nav\n{\n    padding-top: 2%;\n    padding-bottom: 5% !important; \n}\n\n.fontSizejoin\n{\n    border: 1px dashed gray;\n    border-top-left-radius: 1px;\n    border-top-right-radius: 15px;\n    border-bottom-left-radius: 15px;\n    border-bottom-right-radius: 15px;\n}\n\n.card_background_color\n{\n    background-color: #ECEDFF;\n    border-top-right-radius: 20px;\n    border-bottom-right-radius: 20px;\n    border-bottom-left-radius: 20px;\n}\n\n.background_color_button\n{\n    background-color: #DCDFFF;\n    border: #DCDFFF;\n    color: $blue;\n\n}\n\n.bg_nav_white\n{\n    background-color: white;\n    transition: 0.9s;\n}\n\n.padding_custom\n{\n    padding-left: 8% !important; \n    padding-right: 8% !important;\n}\n\ndiv.ruby-menu-demo-header-bg {\n    // background: url(../img/bg.jpg)\n}\n\ndiv.ruby-menu-demo-header-bg div.ruby-menu-demo-download > span {\n    color: #efefef\n}\n\ndiv.ruby-menu-demo-header-bg div.ruby-menu-demo-download > span > span {\n    color: #efefef\n}\n\ndiv.ruby-menu-demo-description {\n    position: relative;\n    width: 980px;\n    height: 160px;\n    margin: 0 auto;\n    padding: 0\n}\n\ndiv.ruby-menu-demo-description img {\n    max-width: 200px;\n    float: left;\n    margin: 50px 20px 0 0\n}\n\nspan.ruby-menu-demo-highlight {\n    color: #333\n}\n\ndiv.ruby-menu-demo-bg-light,div.ruby-menu-demo-bg-dark {\n    width: 980px;\n    height: auto;\n    position: relative;\n    background: #fff;\n    margin: 0 auto;\n    font-family: 'Open Sans',sans-serif;\n    font-size: 16px\n}\n\ndiv.ruby-menu-demo-bg-dark {\n    background: efefef\n}\n\ndiv.ruby-menu-demo-bg-light-c:after,div.ruby-menu-demo-bg-dark-c:after {\n    content: \"\";\n    display: table;\n    clear: both\n}\n\ndiv.ruby-menu-demo-cv-1 {\n    float: left;\n    width: 33%\n}\n\ndiv.ruby-menu-demo-cv-2 {\n    float: left;\n    width: 67%\n}\n\ndiv.ruby-menu-demo-cv-3 {\n    float: left;\n    width: 48%\n}\n\ndiv.ruby-menu-demo-cv-4 {\n    float: left;\n    width: 52%\n}\n\ndiv.ruby-menu-demo-cr-1 {\n    float: left;\n    width: 33%\n}\n\ndiv.ruby-menu-demo-cr-2 {\n    float: left;\n    width: 66%\n}\n\ndiv.ruby-menu-demo-cs-1 {\n    float: left;\n    width: 33%\n}\n\ndiv.ruby-menu-demo-cs-2 {\n    float: left;\n    width: 66%\n}\n\ndiv.ruby-menu-demo-cf-1,div.ruby-menu-demo-cf-2,div.ruby-menu-demo-cf-3,div.ruby-menu-demo-cf-4 {\n    float: left;\n    width: 25%;\n    text-align: center\n}\n\ndiv.ruby-menu-demo-f-icon {\n    width: 80px;\n    height: 80px;\n    border-radius: 50%;\n    margin: 0 auto;\n    padding: 22px;\n    font-size: 30px;\n    background: #efefef;\n    color: #aaa\n}\n\ndiv.ruby-menu-demo-f-title {\n    width: 100%;\n    height: 30px;\n    margin: 0 auto;\n    margin-top: 20px;\n    font-weight: 700;\n    font-size: 18px\n}\n\ndiv.ruby-menu-demo-f-desc {\n    font-size: 14px;\n    line-height: 24px;\n    color: #555;\n    padding: 15px\n}\n\ndiv.ruby-menu-demo-cs-1 table {\n    line-height: 20px\n}\n\ndiv.ruby-menu-demo-cs-1 table tr,div.ruby-menu-demo-cs-1 table td {\n    padding: 0;\n    font-weight: 700\n}\n\ndiv.ruby-menu-demo-cs-1 table td:last-child {\n    padding-top: 5px\n}\n\nh2.ruby-menu-demo-slogan-1,h3.ruby-menu-demo-slogan-1 {\n    font-size: 20px;\n    font-weight: 300;\n    text-transform: uppercase;\n    color: #b1b1b1;\n    margin: 0\n}\n\nh1.ruby-menu-demo-slogan-2,h3.ruby-menu-demo-slogan-2 {\n    font-size: 36px;\n    font-weight: 700;\n    text-transform: none;\n    color: #222;\n    margin: 0\n}\n\np.ruby-menu-demo-slogan-description,p.ruby-menu-demo-slogan-description-2 {\n    font-size: 16px;\n    line-height: 24px;\n    color: #444;\n    margin: 35px 0\n}\n\np.ruby-menu-demo-slogan-description-2 {\n    color: #666;\n    font-weight: 600;\n    margin: -10px 0\n}\n\nspan.ruby-menu-demo-code {\n    color: #888;\n    text-decoration: underline\n}\n\ntd.ruby-menu-demo-theme-td-1 {\n    max-width: 30px;\n    text-align: left;\n    padding: 6px\n}\n\ntd.ruby-menu-demo-theme-td-2 {\n    min-width: 120px;\n    text-align: left;\n    padding: 6px\n}\n\ntd.ruby-menu-demo-theme-td-1:hover {\n    cursor: pointer\n}\n\n.ruby-menu-demo-circle {\n    border-radius: 50%;\n    width: 24px;\n    height: 24px;\n    border: 4px solid #222;\n    display: inline-block;\n    margin: 0\n}\n\n.ruby-menu-demo-color-1 {\n    background: #1aad86\n}\n\n.ruby-menu-demo-color-2 {\n    background: #0c67c2\n}\n\n.ruby-menu-demo-color-3 {\n    background: #ce0661\n}\n\n.ruby-menu-demo-color-4 {\n    background: #ea7500\n}\n\n.ruby-menu-demo-color-5 {\n    background: #74ba27\n}\n\n.ruby-menu-demo-color-6 {\n    background: #ff3264\n}\n\n.ruby-menu-demo-color-7 {\n    background: #fad814\n}\n\n.ruby-menu-demo-color-8 {\n    background: #ccc\n}\n\n.ruby-menu-demo-color-9 {\n    background: #111;\n    border-color: #ccc\n}\n\n.ruby-menu-demo-color-10 {\n    background: #036de2;\n    border-color: #489efd\n}\n\n.ruby-menu-demo-color-11 {\n    background: #f85252;\n    border-color: #444\n}\n\n.ruby-menu-demo-color-12 {\n    background: #ca79d0;\n    border-color: #f2def3\n}\n\n.ruby-menu-demo-color-13 {\n    background: #efefef;\n    border-color: #222\n}\n\n.ruby-menu-demo-color-14 {\n    background: #ccc\n}\n\ndiv.ruby-menu-demo-download {\n    position: absolute;\n    width: auto;\n    top: 55px;\n    right: 0\n}\n\ndiv.ruby-menu-demo-download .fa {\n    font-size: 20px;\n    margin-right: 10px\n}\n\ndiv.ruby-menu-demo-download > span {\n    font-size: 16px;\n    display: block;\n    margin: 10px 26px\n}\n\ndiv.ruby-menu-demo-download > span > span {\n    font-size: 20px;\n    color: #555;\n    font-weight: 700\n}\n\nbutton.ruby-btn {\n    background: #19ad86;\n    border: 2px solid #19ad86;\n    color: #fff;\n    border-radius: 0;\n    padding: 10px 25px;\n    font-size: 16px;\n    font-weight: 700;\n    cursor: pointer\n}\n\nbutton.ruby-btn:hover {\n    background: #fff;\n    color: #19ad86\n}\n\n.switch {\n    display: table-cell;\n    vertical-align: middle;\n    padding: 10px\n}\n\n.cmn-toggle {\n    position: absolute;\n    margin-left: -9999px;\n    visibility: hidden\n}\n\n.cmn-toggle + label {\n    display: block;\n    position: relative;\n    cursor: pointer;\n    outline: none;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none\n}\n\ninput.cmn-toggle-round + label {\n    padding: 2px;\n    margin-top: -10px;\n    width: 40px;\n    height: 20px;\n    background-color: #ddd;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n    border-radius: 20px\n}\n\ninput.cmn-toggle-round + label:before,input.cmn-toggle-round + label:after {\n    display: block;\n    position: absolute;\n    top: 1px;\n    left: 1px;\n    bottom: 1px;\n    content: \"\"\n}\n\ninput.cmn-toggle-round + label:before {\n    right: 1px;\n    background-color: #f1f1f1;\n    -webkit-border-radius: 20px;\n    -moz-border-radius: 20px;\n    -ms-border-radius: 20px;\n    -o-border-radius: 20px;\n    border-radius: 20px;\n    -webkit-transition: background .4s;\n    -moz-transition: background .4s;\n    -o-transition: background .4s;\n    transition: background .4s\n}\n\ninput.cmn-toggle-round + label:after {\n    width: 18px;\n    background-color: #fff;\n    -webkit-border-radius: 100%;\n    -moz-border-radius: 100%;\n    -ms-border-radius: 100%;\n    -o-border-radius: 100%;\n    border-radius: 100%;\n    -webkit-box-shadow: 0 2px 5px rgba(0,0,0,0.3);\n    -moz-box-shadow: 0 2px 5px rgba(0,0,0,0.3);\n    box-shadow: 0 2px 5px rgba(0,0,0,0.3);\n    -webkit-transition: margin .4s;\n    -moz-transition: margin .4s;\n    -o-transition: margin .4s;\n    transition: margin .4s\n}\n\ninput.cmn-toggle-round:checked + label:before,input.cmn-toggle-on + label:before {\n    background-color: #8ce196\n}\n\ninput.cmn-toggle-round:checked + label:after,input.cmn-toggle-on + label:after {\n    margin-left: 20px\n}\n\ninput.cmn-toggle-on:checked + label:before {\n    background-color: #f1f1f1\n}\n\ninput.cmn-toggle-on:checked + label:after {\n    margin-left: 0\n}\n\nimg.iphone7 {\n    max-width: 350px;\n    float: right;\n    margin-right: 0\n}\n\n@media(min-width: 768px) and (max-width:991px) {\n    body {\n        overflow-x:hidden\n    }\n\n    div.ruby-menu-demo-description {\n        position: relative;\n        width: 760px;\n        height: 160px;\n        margin: 0 auto;\n        padding: 0\n    }\n\n    div.ruby-menu-demo-description img {\n        max-width: 200px;\n        float: left;\n        margin: 50px 20px 0 0\n    }\n\n    div.ruby-menu-demo-bg-light,div.ruby-menu-demo-bg-dark {\n        width: 760px;\n        font-size: 14px\n    }\n\n    div.ruby-menu-demo-cs-1 {\n        width: 27%\n    }\n\n    div.ruby-menu-demo-cs-2 {\n        width: 73%\n    }\n\n    td.ruby-menu-demo-theme-td-1 {\n        max-width: 27px;\n        padding: 7px\n    }\n\n    td.ruby-menu-demo-theme-td-2 {\n        min-width: 100px;\n        padding: 7px\n    }\n\n    .ruby-menu-demo-circle {\n        width: 22px;\n        height: 22px;\n        border: 3px solid #222\n    }\n\n    img.iphone7 {\n        max-width: 320px;\n        float: right;\n        margin-right: 20px\n    }\n}\n\n@media(max-width: 767px) {\n    div.ruby-menu-demo-header {\n        width:100%;\n        height: auto\n    }\n\n    div.ruby-menu-demo-description {\n        width: 100%;\n        margin: 0 auto;\n        margin-bottom: 220px;\n        padding: 10px;\n        text-align: center\n    }\n\n    div.ruby-menu-demo-description img {\n        float: none;\n        margin: 90px 0 0\n    }\n\n    div.ruby-menu-demo-download {\n        position: relative;\n        width: auto;\n        top: 25px;\n        right: auto;\n        left: auto\n    }\n\n    div.ruby-menu-demo-download > span {\n        font-size: 20px;\n        margin: 25px auto\n    }\n\n    div.ruby-menu-demo-download > span > span {\n        font-size: 26px\n    }\n\n    button.ruby-btn {\n        padding: 14px 25px;\n        font-size: 16px;\n        text-transform: uppercase\n    }\n\n    div.ruby-menu-demo-bg-light.ruby-menu-demo-switches {\n        display: none\n    }\n\n    div.ruby-menu-demo-bg-light,div.ruby-menu-demo-bg-dark {\n        width: 100%;\n        font-size: 16px;\n        padding: 25px;\n        margin-bottom: -100px\n    }\n\n    div.ruby-menu-demo-cv-1 {\n        width: 100%\n    }\n\n    div.ruby-menu-demo-cv-2 {\n        width: 100%\n    }\n\n    div.ruby-menu-demo-cv-3 {\n        width: 100%\n    }\n\n    div.ruby-menu-demo-cv-4 {\n        width: 100%\n    }\n\n    div.ruby-menu-demo-cr-1 {\n        width: 100%\n    }\n\n    div.ruby-menu-demo-cr-2 {\n        width: 100%;\n        margin-top: 40px\n    }\n\n    div.ruby-menu-demo-cf-1,div.ruby-menu-demo-cf-2,div.ruby-menu-demo-cf-3,div.ruby-menu-demo-cf-4 {\n        float: left;\n        width: 50%;\n        text-align: center\n    }\n\n    div.ruby-menu-demo-f-desc {\n        margin-bottom: 30px\n    }\n\n    img.iphone7 {\n        max-width: 300px;\n        float: none;\n        margin-right: 0 auto\n    }\n}\n\n\n/* theme */\n\ndiv.ruby-wrapper,div.ruby-wrapper.ruby-vertical {\n    background: #f9f9f9;\n    color: #222\n}\n\nul.ruby-menu > li > a {\n    color: #222\n}\n\nul.ruby-menu > li > a:hover,ul.ruby-menu > li:hover > a,ul.ruby-menu > li.ruby-active-menu-item > a:hover,ul.ruby-menu > li.ruby-active-menu-item:hover > a {\n    background: #222;\n    color: #212530;\n}\n\nul.ruby-menu > li.ruby-active-menu-item > a {\n    background: #efefef;\n    color: #222\n}\n\nul.ruby-menu.ruby-menu-dividers > li > a,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social > a {\n    border-left: 1px solid #ddd;\n    border-right: 1px solid #fff\n}\n\nul.ruby-menu.ruby-menu-dividers > li:first-child > a,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social:last-child > a {\n    border-left: none\n}\n\nul.ruby-menu.ruby-vertical.ruby-menu-dividers > li > a {\n    border: none;\n    border-top: 1px solid #ddd;\n    border-bottom: 1px solid #fff\n}\n\nul.ruby-menu.ruby-vertical.ruby-menu-dividers > li:first-child > a {\n    border-top: none\n}\n\nul.ruby-menu.ruby-menu-dividers > li > a:hover,ul.ruby-menu.ruby-menu-dividers > li:hover > a {\n    border-left: 1px solid #222;\n    border-right: 1px solid #222\n}\n\nul.ruby-menu.ruby-vertical.ruby-menu-dividers > li > a:hover,ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li:hover > a {\n    border-bottom: 1px solid #222\n}\n\nul.ruby-menu.ruby-menu-dividers > li.ruby-active-menu-item > a {\n    border-left: 1px solid #efefef;\n    border-right: 1px solid #fff\n}\n\nul.ruby-menu.ruby-vertical.ruby-menu-dividers > li.ruby-active-menu-item > a {\n    border-bottom: 1px solid #fff;\n    border-left: none;\n    border-right: none\n}\n\nul.ruby-menu.ruby-vertical.ruby-menu-dividers > li > a {\n    border-left: none;\n    border-right: none\n}\n\nul.ruby-menu.ruby-vertical.ruby-menu-dividers > li.ruby-active-menu-item > a:hover,ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li.ruby-active-menu-item:hover > a {\n    border-bottom: 1px solid #222;\n    border-left: none\n}\n\nul.ruby-menu > li > ul,ul.ruby-menu > li > ul > li > ul,ul.ruby-menu > li > ul > li > ul > li > ul {\n    border-top: 4px solid #222\n}\n\nul.ruby-menu > li > ul > li > a,ul.ruby-menu > li > ul > li > ul > li > a,ul.ruby-menu > li > ul > li > ul > li > ul > li > a {\n    background: #fff;\n    color: #666\n}\n\nul.ruby-menu > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > a:hover,ul.ruby-menu > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > a:hover,ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {\n    background: #efefef\n}\n\nul.ruby-menu > li.ruby-menu-mega > div,ul.ruby-menu > li.ruby-menu-mega-blog > div,ul.ruby-menu > li.ruby-menu-mega-shop > div {\n    background: #fff;\n    border-top: 4px solid #222\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav {\n    background: #efefef\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a {\n    background: #efefef;\n    color: #666\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a {\n    background: #e6e6e6\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {\n    background: #fff\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a {\n    background: #ddd\n}\n\nul.ruby-menu > li.ruby-menu-mega-shop > div > ul {\n    background: #efefef;\n    border-bottom: 1px solid #ddd\n}\n\nul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {\n    color: #666\n}\n\nul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div {\n    background: #fff\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul li > a,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li > a {\n    color: #555\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul li > a:hover,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li > a:hover {\n    color: #222\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul.ruby-list-with-images li span.ruby-list-desc {\n    color: #999\n}\n\nspan.ruby-c-title,span.ruby-c-title a {\n    color: #222\n}\n\nspan.ruby-c-title a:hover,span.ruby-c-category,span.ruby-c-category a,span.ruby-c-date,span.ruby-c-date a {\n    color: #444\n}\n\nspan.ruby-c-category a:hover,span.ruby-c-date a:hover {\n    color: #222\n}\n\n@media(min-width: 768px) {\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:after {\n        background-color:#222\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover {\n        color: #333\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a:after,ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a:after {\n        border-color: transparent #fff transparent transparent\n    }\n}\n\n@media(max-width: 767px) {\n    ul.ruby-menu > li > a {\n        background:#efefef\n    }\n\n    ul.ruby-menu > li > a:hover,ul.ruby-menu > li:hover > a,ul.ruby-menu > li.ruby-active-menu-item > a:hover {\n        background: #ccc;\n        color: #111\n    }\n\n    ul.ruby-menu > li.ruby-active-menu-item > a {\n        background: #ccc\n    }\n\n    ul.ruby-menu > li > ul > li > a,ul.ruby-menu > li > ul > li > ul > li > a,ul.ruby-menu > li > ul > li > ul > li > ul > li > a,ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {\n        background: #d1d1d1\n    }\n\n    ul.ruby-menu > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > a:hover,ul.ruby-menu > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > a:hover,ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {\n        background: #d9d9d9;\n        color: #111\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > a {\n        background: #e5e5e5\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > a:hover {\n        background: #e1e1e1\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > ul > li > a {\n        background: #efefef\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {\n        background: #fff\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a {\n        background: #bcbcbc\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a {\n        background: #d9d9d9\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a {\n        background: #bcbcbc\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > a,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a {\n        background: #d9d9d9\n    }\n\n    span.ruby-dropdown-toggle:after {\n        color: #fff\n    }\n\n    ul.ruby-menu > li > a:before,ul.ruby-menu > li > ul > li > a:before,ul.ruby-menu > li > ul > li > ul > li > a:before,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:before,ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a:before,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before {\n        background: #333\n    }\n\n    ul.ruby-menu > li > ul > li > a:before,ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a:before,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before {\n        background: #555\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > a:before {\n        background: #777\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > ul > li > a:before {\n        background: #999\n    }\n\n    .c-hamburger span {\n        background: #222\n    }\n\n    .c-hamburger span::before,.c-hamburger span::after {\n        background-color: #222\n    }\n\n    .c-hamburger--htx {\n        background-color: #efefef;\n        color: #222\n    }\n\n    .c-hamburger--htx.is-active {\n        background-color: #ddd\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega > div,ul.ruby-menu > li.ruby-menu-mega-blog > div,ul.ruby-menu > li.ruby-menu-mega-shop > div {\n        border-top: none\n    }\n\n    ul.ruby-menu > li > ul,ul.ruby-menu > li > ul > li > ul,ul.ruby-menu > li > ul > li > ul > li > ul {\n        border-top: none\n    }\n\n    ul.ruby-menu.ruby-menu-dividers > li,ul.ruby-menu.ruby-menu-dividers > li > a,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social > a,ul.ruby-menu.ruby-menu-dividers > li > a:hover,ul.ruby-menu.ruby-menu-dividers > li:hover > a {\n        border: none\n    }\n}\n\n/* transision */\n\nspan.ruby-dropdown-toggle {\n    transition: transform .3s ease\n}\n\nspan.ruby-dropdown-toggle:after {\n    transition: transform .3s ease\n}\n\n@media(min-width: 767px) {\n    ul.ruby-menu > li > a:after {\n        transition:all .3s ease\n    }\n\n    ul.ruby-menu > li > ul > li > a:after,ul.ruby-menu > li > ul > li > ul > li > a:after,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:after {\n        transition: all .3s ease\n    }\n\n    ul.ruby-menu > li > ul,ul.ruby-menu > li > div {\n        transform: translateY(25px);\n        transition: all .3s ease\n    }\n\n    ul.ruby-menu > li:hover > ul,ul.ruby-menu > li:hover > div {\n        transform: translateY(0)\n    }\n\n    ul.ruby-menu.ruby-vertical > li > ul,ul.ruby-menu.ruby-vertical > li > div {\n        transform: translateX(25px);\n        transition: all .3s ease\n    }\n\n    ul.ruby-menu.ruby-vertical > li:hover > ul,ul.ruby-menu.ruby-vertical > li:hover > div {\n        transform: translateX(0)\n    }\n\n    ul.ruby-menu > li > ul > li > ul,ul.ruby-menu > li > ul > li > ul > li > ul,ul.ruby-menu > li > ul > li > ul > li > ul > li > ul {\n        transform: translateX(25px);\n        transition: all .3s ease\n    }\n\n    ul.ruby-menu > li > ul > li:hover > ul,ul.ruby-menu > li > ul > li > ul > li:hover > ul,ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > ul {\n        transform: translateX(0)\n    }\n\n    ul.ruby-menu > li > ul > li.ruby-open-to-left > ul,ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left > ul,ul.ruby-menu > li > ul > li > ul > li > ul > li.ruby-open-to-left > ul {\n        transform: translateX(-25px);\n        transition: all .3s ease\n    }\n\n    ul.ruby-menu > li > ul > li.ruby-open-to-left:hover > ul,ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left:hover > ul,ul.ruby-menu > li > ul > li > ul > li > ul > li.ruby-open-to-left:hover > ul {\n        transform: translateX(0)\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {\n        transform: translateY(-50px);\n        transition: all .5s ease\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog:hover > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > div,ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > div {\n        transform: translateY(0)\n    }\n\n    ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {\n        transform: translateX(50px);\n        transition: all .5s ease\n    }\n\n    ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-blog:hover > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > div,ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > div {\n        transform: translateX(0)\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div {\n        transform: translateY(-50px);\n        transition: all .5s ease\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop:hover > div > ul > li.ruby-active-menu-item > div,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > div {\n        transform: translateY(0)\n    }\n\n    ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-shop > div > ul > li > div {\n        transform: translateX(50px);\n        transition: all .5s ease\n    }\n\n    ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-shop:hover > div > ul > li.ruby-active-menu-item > div,ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-shop > div > ul > li:hover > div {\n        transform: translateX(0)\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:after {\n        -webkit-transition: all .4s ease;\n        transition: all .4s ease\n    }\n}\n\n/* main */\n\n*,:before,:after {\n    -moz-box-sizing: border-box;\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box\n}\n\nbody {\n    font-family: 'Open Sans',sans-serif\n}\n\ndiv.ruby-wrapper {\n    position: relative;\n    width: 100%;\n    height: 50px;\n    margin: 0 auto;\n    background: rgba(51, 51, 51, 0)\n}\n\ndiv.ruby-wrapper:hover {\n    position: relative;\n    width: 100%;\n    height: 50px;\n    margin: 0 auto;\n    background: white;\n    transition: 0.9s !important;\n}\n\ndiv.ruby-wrapper ul {\n    margin: 0;\n    padding: 0;\n    list-style: none\n}\n\ndiv.ruby-wrapper > ul {\n    position: relative\n}\n\nul.ruby-menu > li {\n    float: left;\n    font-size: 14px\n}\n\nul.ruby-menu > li.ruby-menu-right {\n    float: right\n}\n\nul.ruby-menu > li > a {\n    display: block;\n    line-height: 50px;\n    padding: 0 25px 0 15px;\n    color: gray;\n    text-decoration: none;\n    font-family: 'Open Sans',sans-serif;\n    font-weight: 700;\n    text-transform: uppercase\n}\n\nul.ruby-menu > li > a:only-child {\n    padding: 0 15px\n}\n\nul.ruby-menu > li > a:hover,ul.ruby-menu > li:hover > a,ul.ruby-menu > li.ruby-active-menu-item > a:hover,ul.ruby-menu > li.ruby-active-menu-item:hover > a {\n    background: #19ad8500\n}\n\n\nul.ruby-menu > li > a:only-child:after,ul.ruby-menu > li:hover > a:only-child:after {\n    content: ''\n}\n\nul.ruby-menu > li.ruby-active-menu-item > a {\n    background: #17a47c00\n}\n\nul.ruby-menu > li > a .fa {\n    position: relative;\n    width: 24px\n}\n\nul.ruby-menu > li > a > img {\n    // max-width: 16px;\n    display: block\n}\n\nul.ruby-menu > li.ruby-menu-social > a {\n    padding: 0;\n    width: 30px;\n    padding: 0 8px;\n    font-size: 16px\n}\n\nul.ruby-menu > li.ruby-menu-social > a > span {\n    display: none\n}\n\nul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social.ruby-menu-search > a {\n    transition: all .5s ease;\n    max-height: 50px;\n    width: 30px;\n    transition: all .5s ease;\n    transition-delay: .3s\n}\n\nul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a:hover,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social.ruby-menu-search > a:hover {\n    width: 120px\n}\n\nul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a:hover > span input,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social.ruby-menu-search > a:hover > span input {\n    transform: scaleY(1);\n    max-width: 80px\n}\n\nul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a span,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social.ruby-menu-search > a span {\n    display: inline\n}\n\nul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a > span input,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social.ruby-menu-search > a > span input {\n    position: absolute;\n    width: 80px;\n    height: 50px;\n    line-height: 50px;\n    margin: 0;\n    background: none;\n    color: #efefef;\n    border: none;\n    font-family: 'Open Sans',sans-serif;\n    font-size: 14px;\n    font-weight: 700;\n    text-transform: uppercase;\n    max-width: 0;\n    transform: scaleY(0);\n    transition: all .5s ease;\n    transition-delay: .3s\n}\n\nul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a > span input:focus {\n    outline: none;\n    color: #efefef\n}\n\nul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a > span input::-webkit-input-placeholder {\n    color: #efefef\n}\n\nul.ruby-menu.ruby-menu-dividers > li > a,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social > a {\n    border-left: 1px solid #111;\n    border-right: 1px solid #666\n}\n\nul.ruby-menu.ruby-menu-dividers > li:first-child > a,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social:last-child > a {\n    border-left: none\n}\n\nul.ruby-menu.ruby-vertical.ruby-menu-dividers > li > a {\n    border: none;\n    border-top: 1px solid #111;\n    border-bottom: 1px solid #666\n}\n\nul.ruby-menu.ruby-vertical.ruby-menu-dividers > li:first-child > a {\n    border-top: none\n}\n\nul.ruby-menu.ruby-menu-dividers > li > a:hover,ul.ruby-menu.ruby-menu-dividers > li:hover > a {\n    border-right: 1px solid #19ad86\n}\n\nul.ruby-menu.ruby-vertical.ruby-menu-dividers > li > a:hover,ul.ruby-menu.ruby-vertical.ruby-menu-dividers > li:hover > a {\n    border-bottom: 1px solid #19ad86\n}\n\nul.ruby-menu.ruby-menu-dividers > li.ruby-active-menu-item > a {\n    border-right: 1px solid #17a47d\n}\n\nul.ruby-menu.ruby-vertical.ruby-menu-dividers > li.ruby-active-menu-item > a {\n    border-bottom: 1px solid #17a47d\n}\n\nul.ruby-menu > li > ul,ul.ruby-menu > li > ul > li > ul,ul.ruby-menu > li > ul > li > ul > li > ul {\n    position: absolute;\n    -webkit-box-shadow: 0 8px 24px -5px #ccc;\n    -moz-box-shadow: 0 8px 24px -5px #ccc;\n    box-shadow: 0 8px 24px -5px #ccc;\n    border-top: 4px solid #fbfbfb00\n}\n\nul.ruby-menu > li > ul > li,ul.ruby-menu > li > ul > li > ul > li {\n    position: relative\n}\n\nul.ruby-menu > li > ul > li > a,ul.ruby-menu > li > ul > li > ul > li > a,ul.ruby-menu > li > ul > li > ul > li > ul > li > a {\n    display: block;\n    width: 170px;\n    line-height: 40px;\n    padding: 0 35px 0 25px;\n    background: #fff;\n    color: #666;\n    text-decoration: none;\n    font-size: 14px\n}\n\nul.ruby-menu > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > a:hover,ul.ruby-menu > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > a:hover,ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {\n    background: #efefef\n}\n\nul.ruby-menu > li > ul > li > a:only-child:after,ul.ruby-menu > li > ul > li > ul > li > a:only-child:after,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:only-child:after {\n    content: \"\"\n}\n\nul.ruby-menu > li > ul > li > a .fa,ul.ruby-menu > li > ul > li > ul > li > a .fa,ul.ruby-menu > li > ul > li > ul > li > ul > li > a .fa {\n    position: relative;\n    width: 24px\n}\n\nul.ruby-menu > li.ruby-menu-right > ul {\n    right: 0\n}\n\nul.ruby-menu > li > ul > li > ul,ul.ruby-menu > li > ul > li > ul > li > ul {\n    left: 170px;\n    top: -4px;\n    z-index: 100\n}\n\nul.ruby-menu > li > ul > li.ruby-open-to-left > ul,ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left > ul {\n    left: auto;\n    right: 170px\n}\n\nul.ruby-menu > li.ruby-menu-mega > div,ul.ruby-menu > li.ruby-menu-mega-blog > div,ul.ruby-menu > li.ruby-menu-mega-shop > div {\n    position: absolute;\n    width: 100%;\n    height: auto;\n    left: 0;\n    // margin-top: 5% !important;\n    background: #fff;\n    margin-top: 15px !important;\n    border-top: 1px dashed gray;\n    overflow: hidden;\n    -webkit-box-shadow: 0 8px 24px -5px #ccc;\n    -moz-box-shadow: 0 8px 24px -5px #ccc;\n    box-shadow: 0 8px 24px -5px #ccc\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav {\n    position: relative;\n    width: 200px;\n    height: 100%;\n    left: 0;\n    top: 0;\n    background: #efefef\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li {\n    font-size: 14px\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a {\n    display: block;\n    line-height: 40px;\n    padding: 0 15px;\n    background: #efefef;\n    color: #666;\n    text-decoration: none\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a {\n    background: #e6e6e6\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {\n    position: absolute;\n    width: 780px;\n    height: auto;\n    min-height: 100%;\n    left: 200px;\n    top: 0;\n    background: #fff\n}\n\nul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a {\n    background: #ddd\n}\n\nul.ruby-menu > li.ruby-menu-mega-shop > div {\n    text-align: center;\n    z-index: 999999\n}\n\nul.ruby-menu > li.ruby-menu-mega-shop > div > ul {\n    width: 100%;\n    background: #efefef;\n    margin: 0 auto;\n    padding: 0;\n    border-bottom: 1px solid #ddd;\n    font-size: 0;\n    z-index: 100\n}\n\nul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li {\n    display: inline-block;\n    margin: 0\n}\n\nul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {\n    display: block;\n    padding: 20px 15px;\n    text-transform: uppercase;\n    font-weight: 700;\n    font-size: 14px;\n    font-stretch: expanded;\n    color: #666\n}\n\nul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > a,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a {\n    text-decoration: none\n}\n\nul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {\n    position: relative;\n    text-decoration: none;\n    display: inline-block\n}\n\nul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div {\n    position: absolute;\n    width: 100%;\n    left: 0;\n    top: auto;\n    margin-top: 1px;\n    text-align: left;\n    background: #fff;\n    z-index: -1\n}\n\ndiv.ruby-grid,div.ruby-grid-lined {\n    position: relative;\n    width: 100%;\n    padding: 0;\n    margin: 0\n}\n\ndiv.ruby-grid > div.ruby-row {\n    position: relative;\n    width: 100%;\n    height: auto\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-row [class^=\"ruby-col\"] {\n    margin-top: 16px\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-row:first-of-type [class^=\"ruby-col\"] {\n    margin-top: 0\n}\n\ndiv.ruby-grid.ruby-grid-lined > div.ruby-row:after {\n    content: \"\";\n    width: 100%;\n    left: 0;\n    bottom: 0;\n    background: -webkit-linear-gradient(left,rgba(204,204,204,0) 0%,rgba(204,204,204,0.48) 24%,rgba(204,204,204,1) 50%,rgba(204,204,204,0.42) 79%,rgba(204,204,204,0) 100%)\n}\n\ndiv.ruby-grid.ruby-grid-lined > div.ruby-row:last-child:after {\n    height: 0\n}\n\ndiv.ruby-grid > div.ruby-row::after {\n    content: \"\";\n    display: table;\n    clear: both\n}\n\ndiv.ruby-grid > div.ruby-row [class^=\"ruby-col\"] {\n    position: relative;\n    float: left;\n    height: auto\n}\n\ndiv.ruby-grid > div.ruby-row > [class^=\"ruby-col\"] {\n    padding: 16px\n}\n\ndiv.ruby-grid > div.ruby-row > [class^=\"ruby-col\"] [class^=\"ruby-col\"] {\n    padding-left: 16px\n}\n\ndiv.ruby-grid > div.ruby-row > [class^=\"ruby-col\"] [class^=\"ruby-col\"]:first-of-type {\n    padding-left: 0\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-1 {\n    width: 8.33%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-2 {\n    width: 16.66%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-3 {\n    width: 25%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-4 {\n    width: 33.33%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-5 {\n    width: 41.66%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-6 {\n    width: 50%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-7 {\n    width: 58.33%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-8 {\n    width: 66.66%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-9 {\n    width: 75%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-10 {\n    width: 83.33%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-11 {\n    width: 91.66%\n}\n\ndiv.ruby-grid > div.ruby-row div.ruby-col-12 {\n    width: 100%\n}\n\ndiv.ruby-grid.ruby-grid-lined > div.ruby-row > div[class^=\"ruby-col\"]:after {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    width: 1px;\n    height: 100%;\n    right: 0;\n    background: -webkit-linear-gradient(top,rgba(204,204,204,0) 0%,rgba(204,204,204,0.48) 24%,rgba(204,204,204,1) 50%,rgba(204,204,204,0.42) 79%,rgba(204,204,204,0) 100%)\n}\n\ndiv.ruby-grid.ruby-grid-lined > div.ruby-row > div[class^=\"ruby-col\"]:last-child:after {\n    width: 0\n}\n\ndiv.ruby-grid img {\n    position: relative;\n    max-width: 100%;\n    height: auto;\n    display: block\n}\n\nh3.ruby-list-heading {\n    font-size: 14px;\n    line-height: 24px;\n    font-weight: 700;\n    margin: 0\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul {\n    margin: 0;\n    margin-top: 10px\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul li,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li {\n    position: relative;\n    font-size: 14px;\n    line-height: 28px;\n    display: block;\n    width: 100%\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul li > a,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li > a {\n    text-decoration: none;\n    color: #555;\n    display: inline-block\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul li > a:hover,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li > a:hover {\n    color: #222;\n    text-decoration: underline\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul li .fa,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div ul > li .fa {\n    position: relative;\n    width: 24px\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul.ruby-list-with-images li {\n    height: 50px\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul.ruby-list-with-images li span.ruby-list-desc {\n    font-size: 11px;\n    display: block;\n    position: absolute;\n    top: 16px;\n    left: 72px;\n    color: #999\n}\n\nul.ruby-menu > li.ruby-menu-mega > div ul li > a > img {\n    float: left;\n    width: 60px;\n    margin-right: 12px\n}\n\nspan.ruby-c-title,span.ruby-c-category,span.ruby-c-date {\n    position: relative;\n    display: block\n}\n\nspan.ruby-c-title a,span.ruby-c-category a,span.ruby-c-date a {\n    text-decoration: none\n}\n\nspan.ruby-c-title,span.ruby-c-title a {\n    font-size: 14px;\n    font-weight: 700;\n    text-transform: capitalize;\n    line-height: 20px;\n    margin-top: -5px;\n    color: #222\n}\n\nspan.ruby-c-title a:hover {\n    color: #444;\n    text-decoration: underline\n}\n\nspan.ruby-c-category,span.ruby-c-category a {\n    font-size: 11px;\n    margin: 9px 0;\n    color: #444\n}\n\nspan.ruby-c-date,span.ruby-c-date a {\n    font-size: 11px;\n    color: #444\n}\n\nspan.ruby-c-category a:hover,span.ruby-c-date a:hover {\n    color: #19ad86\n}\n\ndiv.ruby-c-inline {\n    display: block;\n    position: relative;\n    height: 14px;\n    margin: 7px 0\n}\n\ndiv.ruby-c-inline span.ruby-c-category,div.ruby-c-inline span.ruby-c-date {\n    position: absolute;\n    display: inline-block\n}\n\ndiv.ruby-c-inline span.ruby-c-date {\n    right: 0\n}\n\ndiv.ruby-c-inline span.ruby-c-category,div.ruby-c-inline span.ruby-c-category a {\n    margin: 0\n}\n\nspan.ruby-c-content {\n    display: block;\n    position: relative;\n    top: 7px;\n    font-size: 12px;\n    line-height: 18px;\n    text-align: justify\n}\n\n.ruby-wrapper .visible-xs {\n    visibility: hidden;\n    position: absolute\n}\n\n@media(min-width: 768px) {\n    div.ruby-wrapper.ruby-menu-transparent {\n        background:none\n    }\n\n    div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li.ruby-active-menu-item > a {\n        background: none\n    }\n\n    div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li.ruby-menu-social > a {\n        border: none\n    }\n\n    div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu.ruby-menu-dividers > li > a {\n        border: none\n    }\n\n    div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li:hover > a,div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li > a:hover,div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu.ruby-menu-dividers > li:hover > a,div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu.ruby-menu-dividers > li > a:hover {\n        background: none;\n        color: #e2e2e2\n    }\n\n    div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a:hover,div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li.ruby-menu-social.ruby-menu-search:hover > a {\n        background: none\n    }\n\n    div.ruby-wrapper.ruby-menu-full-width {\n        width: 100%\n    }\n\n    div.ruby-wrapper.ruby-menu-full-width > ul.ruby-menu {\n        width: 980px;\n        margin: 0 auto\n    }\n\n    ul.ruby-menu > li > ul,ul.ruby-menu > li > ul > li > ul,ul.ruby-menu > li > ul > li > ul > li > ul {\n        visibility: hidden;\n        opacity: 0\n    }\n\n    ul.ruby-menu > li:hover > ul,ul.ruby-menu > li > ul > li:hover > ul,ul.ruby-menu > li > ul > li > ul > li:hover > ul {\n        visibility: visible;\n        opacity: 1\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega > div,ul.ruby-menu > li.ruby-menu-mega-blog > div,ul.ruby-menu > li.ruby-menu-mega-shop > div {\n        visibility: hidden;\n        opacity: 0\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega:hover > div,ul.ruby-menu > li.ruby-menu-mega-blog:hover > div,ul.ruby-menu > li.ruby-menu-mega-shop:hover > div {\n        visibility: visible;\n        opacity: 1\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {\n        visibility: hidden;\n        opacity: 0\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog:hover > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > div {\n        visibility: visible;\n        opacity: 1\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > div {\n        visibility: visible;\n        opacity: 1;\n        z-index: 101\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div {\n        visibility: hidden;\n        opacity: 0\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop:hover > div > ul > li.ruby-active-menu-item > div,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > div {\n        visibility: visible;\n        opacity: 1\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:after {\n        height: 1px;\n        position: absolute;\n        content: '';\n        background-color: #19ad86;\n        width: 0\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before {\n        top: 10px;\n        left: 5%\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:after {\n        bottom: 10px;\n        right: 5%\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover,.snip1217 .current a {\n        color: #333\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover:before,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a:before,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover:after,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a:after,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > a:before,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > a:after {\n        width: 90%\n    }\n\n    ul.ruby-menu > li > a:after {\n        font-family: \"Font Awesome\\ 5 Free\";\n        text-decoration: none;\n        content: '\\f107';\n        position: absolute;\n        margin-left: 5px\n    }\n\n    ul.ruby-menu > li:hover > a:after {\n        -webkit-transform: rotate(-180deg);\n        -moz-transform: rotate(-180deg);\n        -o-transform: rotate(-180deg);\n        -ms-transform: rotate(-180deg);\n        transform: rotate(-180deg)\n    }\n\n    ul.ruby-menu > li > ul > li > a:after,ul.ruby-menu > li > ul > li > ul > li > a:after,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:after {\n        font-family: \"FontAwesome\";\n        text-decoration: none;\n        font-size: 16px;\n        padding: 0;\n        content: '\\f105';\n        position: absolute;\n        right: 15px\n    }\n\n    ul.ruby-menu > li > ul > li:hover > a:after,ul.ruby-menu > li > ul > li > ul > li:hover > a:after,ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a:after {\n        -webkit-transform: rotate(-180deg);\n        -moz-transform: rotate(-180deg);\n        -o-transform: rotate(-180deg);\n        -ms-transform: rotate(-180deg);\n        transform: rotate(-180deg)\n    }\n\n    ul.ruby-menu > li > ul > li.ruby-open-to-left > a:after,ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left > a:after,ul.ruby-menu > li > ul > li > ul > li > ul > li.ruby-open-to-left > a:after {\n        content: '\\f104';\n        right: auto;\n        left: 10px\n    }\n\n    ul.ruby-menu > li > ul > li.ruby-open-to-left:hover > a:after,ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left:hover > a:after,ul.ruby-menu > li > ul > li > ul > li > ul > li.ruby-open-to-left:hover > a:after {\n        -webkit-transform: rotate(-180deg);\n        -moz-transform: rotate(-180deg);\n        -o-transform: rotate(-180deg);\n        -ms-transform: rotate(-180deg);\n        transform: rotate(-180deg)\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a:after,ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a:after {\n        content: \"\";\n        position: absolute;\n        right: 0;\n        margin-top: 13px;\n        width: 0;\n        height: 0;\n        border-style: solid;\n        border-width: 6px 8px 6px 0;\n        border-color: transparent #fff transparent transparent\n    }\n}\n\n/* responsive */\n\n@media(max-width: 767px) {\n    .menu-mob\n    {\n        display: block;\n        background-color: white;\n    }\n    .menu_active\n    {\n        display: none;\n    }\n\n    div.ruby-wrapper .hidden-xs {\n        visibility:hidden;\n        display: none\n    }\n\n    div.ruby-wrapper {\n        position: absolute;\n        width: 100%;\n        top: 0;\n        background: #111\n    }\n\n    .ruby-wrapper .visible-xs {\n        visibility: visible;\n        position: absolute;\n        left: 0;\n        top: 0\n    }\n\n    div.ruby-wrapper > ul {\n        position: absolute;\n        top: 50px;\n        width: 100%\n    }\n\n    ul.ruby-menu > li,ul.ruby-menu > li.ruby-menu-right {\n        float: none\n    }\n\n    ul.ruby-menu > li > a {\n        padding: 0 65px;\n        background: #19ad86\n    }\n\n    ul.ruby-menu > li > a:only-child {\n        padding: 0 65px\n    }\n\n    ul.ruby-menu > li > a:hover,ul.ruby-menu > li:hover > a,ul.ruby-menu > li.ruby-active-menu-item > a:hover {\n        background: #127e61\n    }\n\n    ul.ruby-menu > li.ruby-active-menu-item > a {\n        background: #159572\n    }\n\n    ul.ruby-menu > li.ruby-menu-social > a > span {\n        display: block\n    }\n\n    ul.ruby-menu > li > ul,ul.ruby-menu > li > ul > li > ul,ul.ruby-menu > li > ul > li > ul > li > ul {\n        position: relative;\n        width: 100%;\n        -webkit-box-shadow: none;\n        -moz-box-shadow: none;\n        box-shadow: none;\n        border-top: none\n    }\n\n    ul.ruby-menu > li,ul.ruby-menu > li > ul > li,ul.ruby-menu > li > ul > li > ul > li,ul.ruby-menu > li > ul > li > ul > li > ul > li {\n        position: relative\n    }\n\n    ul.ruby-menu > li > ul > li > a,ul.ruby-menu > li > ul > li > ul > li > a,ul.ruby-menu > li > ul > li > ul > li > ul > li > a {\n        width: 100%;\n        line-height: 50px;\n        padding: 0 80px;\n        background: #d1d1d1\n    }\n\n    ul.ruby-menu > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > a:hover,ul.ruby-menu > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > a:hover,ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {\n        background: #d9d9d9;\n        color: #111\n    }\n\n    ul.ruby-menu > li > ul > li > ul,ul.ruby-menu > li > ul > li > ul > li > ul {\n        left: auto;\n        top: auto;\n        z-index: auto\n    }\n\n    ul.ruby-menu > li > ul > li.ruby-open-to-left > ul,ul.ruby-menu > li > ul > li > ul > li.ruby-open-to-left > ul {\n        left: auto;\n        right: auto\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > a {\n        background: #e5e5e5;\n        padding: 0 95px\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > a:hover {\n        background: #e1e1e1\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > ul > li > a {\n        background: #efefef;\n        padding: 0 110px\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > ul > li:hover > a,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:hover {\n        background: #fff\n    }\n\n    ul.ruby-menu > li.ruby-menu-social > a {\n        border: none\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega,ul.ruby-menu > li.ruby-menu-mega-blog,ul.ruby-menu > li.ruby-menu-mega-shop {\n        position: relative\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega > div,ul.ruby-menu > li.ruby-menu-mega-blog > div,ul.ruby-menu > li.ruby-menu-mega-shop > div {\n        position: relative;\n        top: auto;\n        left: auto;\n        border-top: none;\n        -webkit-box-shadow: none;\n        -moz-box-shadow: none;\n        box-shadow: none\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav {\n        width: 100%;\n        height: auto;\n        left: auto;\n        top: auto\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li {\n        position: relative\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a {\n        line-height: 50px;\n        padding: 0 75px;\n        background: #d1d1d1;\n        color: #222\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li.ruby-active-menu-item > a {\n        background: #bcbcbc\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {\n        position: relative;\n        width: 100%;\n        min-height: auto;\n        left: auto;\n        top: auto;\n        z-index: auto\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li:hover > a {\n        background: #d9d9d9\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div {\n        position: relative;\n        text-align: left\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul {\n        position: relative;\n        border: none;\n        font-size: 14px;\n        margin-bottom: -1px\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li {\n        position: relative;\n        display: block;\n        margin-top: -1px\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {\n        padding: 0 80px;\n        line-height: 50px;\n        max-height: 50px;\n        text-transform: none;\n        font-weight: 400;\n        background: #d1d1d1;\n        color: #222;\n        border: none\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a {\n        background: #bcbcbc\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li:hover > a,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:hover,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li.ruby-active-menu-item > a {\n        background: #d9d9d9\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {\n        display: block\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div {\n        position: relative;\n        top: 0;\n        z-index: 9999;\n        margin: 0\n    }\n\n    ul.ruby-menu > li.ruby-menu-social img {\n        display: inline-table;\n        position: absolute;\n        top: 15px\n    }\n\n    ul.ruby-menu > li.ruby-menu-social > a {\n        width: 100%\n    }\n\n    ul.ruby-menu > li.ruby-menu-social .fa {\n        position: absolute;\n        top: 17px\n    }\n\n    ul.ruby-menu > li.ruby-menu-social span {\n        line-height: 50px;\n        padding: 0 25px\n    }\n\n    span.ruby-dropdown-toggle {\n        position: absolute;\n        width: 50px;\n        height: 50px;\n        max-width: 50px;\n        max-height: 50px;\n        left: 0;\n        top: 0;\n        padding: 10px 17px;\n        z-index: 1000000;\n        cursor: pointer\n    }\n\n    span.ruby-dropdown-toggle:after {\n        font-family: \"FontAwesome\";\n        text-decoration: none;\n        content: '\\f107';\n        color: #fff;\n        font-size: 25px;\n        right: 0\n    }\n\n    span.ruby-dropdown-toggle.ruby-dropdown-toggle-rotate {\n        -webkit-transform: rotate(180deg);\n        -moz-transform: rotate(180deg);\n        -o-transform: rotate(180deg);\n        -ms-transform: rotate(180deg);\n        transform: rotate(180deg)\n    }\n\n    ul.ruby-menu > li > a:before,ul.ruby-menu > li > ul > li > a:before,ul.ruby-menu > li > ul > li > ul > li > a:before,ul.ruby-menu > li > ul > li > ul > li > ul > li > a:before,ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a:before,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before {\n        content: \"\";\n        width: 50px;\n        height: 50px;\n        background: #333;\n        position: absolute;\n        left: 0;\n        top: 0\n    }\n\n    ul.ruby-menu > li > ul > li > a:before,ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > a:before,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a:before {\n        background: #555\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > a:before {\n        background: #777\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > ul > li > a:before {\n        background: #999\n    }\n\n    ul.ruby-menu > li > ul > li > ul > li > ul,ul.ruby-menu > li > ul > li > ul,ul.ruby-menu > li > ul,ul.ruby-menu,ul.ruby-menu > li.ruby-menu-mega > div,ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div,ul.ruby-menu > li.ruby-menu-mega-blog > div,ul.ruby-menu > li.ruby-menu-mega-shop > div {\n        max-height: 0;\n        transform: scaleY(0);\n        overflow: hidden\n    }\n\n    ul.ruby-menu > li > ul.ruby-mobile-sublevel-show,ul.ruby-menu > li > ul > li > ul.ruby-mobile-sublevel-show,ul.ruby-menu > li > ul > li > ul > li > ul.ruby-mobile-sublevel-show,ul.ruby-menu.ruby-mobile-sublevel-show,ul.ruby-menu > li.ruby-menu-mega > div.ruby-mobile-sublevel-show,ul.ruby-menu > li.ruby-menu-mega-blog > div.ruby-mobile-sublevel-show,ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div.ruby-mobile-sublevel-show,ul.ruby-menu > li.ruby-menu-mega-shop > div.ruby-mobile-sublevel-show,ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > div.ruby-mobile-sublevel-show {\n        max-height: 20000px;\n        transform: scaleY(1)\n    }\n\n    div.ruby-grid > div.ruby-row div.ruby-row [class^=\"ruby-col\"] {\n        margin-top: 0\n    }\n\n    div.ruby-grid > div.ruby-row div.ruby-row:first-of-type [class^=\"ruby-col\"] {\n        margin-top: 0\n    }\n\n    div.ruby-grid.ruby-grid-lined > div.ruby-row:after {\n        height: 0\n    }\n\n    div.ruby-grid > div.ruby-row > [class^=\"ruby-col\"] {\n        padding: 0\n    }\n\n    div.ruby-grid > div.ruby-row > [class^=\"ruby-col\"] [class^=\"ruby-col\"] {\n        padding-left: 0\n    }\n\n    div.ruby-grid > div.ruby-row > [class^=\"ruby-col\"] [class^=\"ruby-col\"]:first-of-type {\n        padding-left: 0\n    }\n\n    div.ruby-grid > div.ruby-row div.ruby-col-1,div.ruby-grid > div.ruby-row div.ruby-col-2,div.ruby-grid > div.ruby-row div.ruby-col-3,div.ruby-grid > div.ruby-row div.ruby-col-4,div.ruby-grid > div.ruby-row div.ruby-col-5,div.ruby-grid > div.ruby-row div.ruby-col-6,div.ruby-grid > div.ruby-row div.ruby-col-7,div.ruby-grid > div.ruby-row div.ruby-col-8,div.ruby-grid > div.ruby-row div.ruby-col-9,div.ruby-grid > div.ruby-row div.ruby-col-10,div.ruby-grid > div.ruby-row div.ruby-col-11,div.ruby-grid > div.ruby-row div.ruby-col-12 {\n        width: 100%;\n        padding: 20px 30px\n    }\n\n    div.ruby-grid.ruby-grid-lined > div.ruby-row > div[class^=\"ruby-col\"]:after {\n        width: 0\n    }\n\n    div.ruby-grid img {\n        position: relative;\n        max-width: 100%;\n        height: auto;\n        display: block\n    }\n\n    div.ruby-grid > div.ruby-row::after {\n        content: \"\";\n        display: table;\n        clear: both\n    }\n\n    .c-hamburger {\n        display: block;\n        position: relative;\n        overflow: hidden;\n        margin: 0;\n        padding: 0;\n        width: 50px;\n        height: 50px;\n        font-size: 0;\n        text-indent: -9999px;\n        -webkit-appearance: none;\n        -moz-appearance: none;\n        appearance: none;\n        box-shadow: none;\n        border-radius: none;\n        border: none;\n        cursor: pointer;\n        -webkit-transition: background .3s;\n        transition: background .3s\n    }\n\n    .c-hamburger:focus {\n        outline: none\n    }\n\n    .c-hamburger span {\n        display: block;\n        position: absolute;\n        top: 24px;\n        left: 8px;\n        right: 8px;\n        height: 3px;\n        background: #fff\n    }\n\n    .c-hamburger span::before,.c-hamburger span::after {\n        position: absolute;\n        display: block;\n        left: 0;\n        width: 100%;\n        height: 3px;\n        background-color: #fff;\n        content: \"\"\n    }\n\n    .c-hamburger span::before {\n        top: -10px\n    }\n\n    .c-hamburger span::after {\n        bottom: -10px\n    }\n\n    .c-hamburger--htx {\n        background-color: #19ad86\n    }\n\n    .c-hamburger--htx span {\n        -webkit-transition: background 0 .3s;\n        transition: background 0 .3s\n    }\n\n    .c-hamburger--htx span::before,.c-hamburger--htx span::after {\n        -webkit-transition-duration: 0.3s,.3s;\n        transition-duration: 0.3s,.3s;\n        -webkit-transition-delay: 0.3s,0;\n        transition-delay: 0.3s,0\n    }\n\n    .c-hamburger--htx span::before {\n        -webkit-transition-property: top,-webkit-transform;\n        transition-property: top,transform\n    }\n\n    .c-hamburger--htx span::after {\n        -webkit-transition-property: bottom,-webkit-transform;\n        transition-property: bottom,transform\n    }\n\n    .c-hamburger--htx.is-active {\n        background-color: #333\n    }\n\n    .c-hamburger--htx.is-active span {\n        background: none\n    }\n\n    .c-hamburger--htx.is-active span::before {\n        top: 0;\n        -webkit-transform: rotate(45deg);\n        -ms-transform: rotate(45deg);\n        transform: rotate(45deg)\n    }\n\n    .c-hamburger--htx.is-active span::after {\n        bottom: 0;\n        -webkit-transform: rotate(-45deg);\n        -ms-transform: rotate(-45deg);\n        transform: rotate(-45deg)\n    }\n\n    .c-hamburger--htx.is-active span::before,.c-hamburger--htx.is-active span::after {\n        -webkit-transition-delay: 0s,.3s;\n        transition-delay: 0s,.3s\n    }\n\n    ul.ruby-menu.ruby-menu-dividers > li,ul.ruby-menu.ruby-menu-dividers > li > a,ul.ruby-menu.ruby-menu-dividers > li.ruby-menu-social > a,ul.ruby-menu.ruby-menu-dividers > li > a:hover,ul.ruby-menu.ruby-menu-dividers > li:hover > a {\n        border: none\n    }\n\n    div.ruby-wrapper.ruby-menu-transparent > ul.ruby-menu > li.ruby-active-menu-item > a {\n        padding-left: 45px\n    }\n\n    ul.ruby-menu > li.ruby-menu-social.ruby-menu-search > a {\n        display: none\n    }\n}\n\n@media(min-width: 768px) and (max-width:991px) {\n    .ruby-wrapper .hidden-md {\n        visibility:hidden;\n        display: none\n    }\n\n    div.ruby-wrapper {\n        width: 760px\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav {\n        width: 170px\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {\n        width: 590px;\n        left: 170px\n    }\n\n    ul.ruby-menu.ruby-vertical > li.ruby-menu-mega > div,ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-blog > div,ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-shop > div {\n        width: 560px\n    }\n\n    ul.ruby-menu.ruby-vertical > li.ruby-menu-mega-blog > div > ul.ruby-menu-mega-blog-nav > li > div {\n        width: 360px\n    }\n\n    span.ruby-c-date {\n        display: none;\n        visibility: hidden;\n        opacity: 0\n    }\n\n    div.ruby-grid > div.ruby-row div.ruby-col-3-md {\n        width: 25%\n    }\n\n    div.ruby-grid > div.ruby-row div.ruby-col-4-md {\n        width: 33.33%\n    }\n\n    div.ruby-grid > div.ruby-row div.ruby-col-6-md {\n        width: 50%\n    }\n\n    div.ruby-grid > div.ruby-row div.ruby-col-12-md {\n        width: 100%\n    }\n\n    div.ruby-grid.ruby-grid-lined > div.ruby-row:after,div.ruby-grid.ruby-grid-lined > div.ruby-row > div[class^=\"ruby-col\"]:after {\n        background: none\n    }\n\n    ul.ruby-menu > li.ruby-menu-mega-shop > div > ul > li > a {\n        padding: 20px 5px;\n        font-size: 12px;\n        font-stretch: condensed;\n        color: #666\n    }\n}\n","@mixin break-point {\n  position: fixed;\n  left: -$sidebar-width;\n  &.collapsed {\n    left: -$sidebar-collapsed-width;\n  }\n  &.toggled {\n    left: 0;\n    .overlay {\n      display: block;\n    }\n  }\n  &.rtl {\n    left: auto;\n    right: -$sidebar-width;\n    &.collapsed {\n      left: auto;\n      right: -$sidebar-collapsed-width;\n    }\n    &.toggled {\n      left: auto;\n      right: 0;\n    }\n  }\n}\n\n.pro-sidebar {\n  color: $sidebar-color;\n  height: 100%;\n  width: $sidebar-width;\n  min-width: $sidebar-width;\n  text-align: left;\n  transition: width, left, right, 0.3s;\n  position: relative;\n  z-index: 1009;\n  > .pro-sidebar-inner {\n    background: $sidebar-bg-color;\n    height: 100%;\n    position: relative;\n    z-index: 101;\n\n    > img.sidebar-bg {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      object-position: center;\n      position: absolute;\n      opacity: 0.3;\n      left: 0;\n      top: 0;\n      z-index: 100;\n    }\n\n    > .pro-sidebar-layout {\n      height: 100%;\n      overflow-y: auto;\n      overflow-x: hidden;\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      z-index: 101;\n\n      .pro-sidebar-header {\n        border-bottom: 1px solid rgba($sidebar-color, 0.2);\n      }\n      .pro-sidebar-content {\n        flex-grow: 1;\n      }\n      .pro-sidebar-footer {\n        border-top: 1px solid rgba($sidebar-color, 0.2);\n      }\n      ul {\n        list-style-type: none;\n        padding: 0;\n        margin: 0;\n      }\n    }\n  }\n\n  .overlay {\n    position: fixed;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: rgba(#000, 0.3);\n    z-index: 100;\n    display: none;\n  }\n\n  &.collapsed {\n    width: $sidebar-collapsed-width;\n    min-width: $sidebar-collapsed-width;\n  }\n\n  &.rtl {\n    text-align: right;\n    direction: rtl;\n  }\n\n  &.xs {\n    @media (max-width: $breakpoint-xs) {\n      @include break-point;\n    }\n  }\n  &.sm {\n    @media (max-width: $breakpoint-sm) {\n      @include break-point;\n    }\n  }\n  &.md {\n    @media (max-width: $breakpoint-md) {\n      @include break-point;\n    }\n  }\n  &.lg {\n    @media (max-width: $breakpoint-lg) {\n      @include break-point;\n    }\n  }\n  &.xl {\n    @media (max-width: $breakpoint-xl) {\n      @include break-point;\n    }\n  }\n  &.xxl {\n    @media (max-width: $breakpoint-xxl) {\n      @include break-point;\n    }\n  }\n}\n","$sidebar-bg-color: #1d1d1d !default;\n$sidebar-color: #adadad !default;\n$sidebar-width: 270px !default;\n$sidebar-collapsed-width: 80px !default;\n$highlight-color: #d8d8d8 !default;\n$submenu-bg-color: #2b2b2b !default;\n$submenu-bg-color-collapsed: #2b2b2b !default;\n$icon-bg-color: #2b2b2b !default;\n$icon-size: 35px !default;\n$submenu-indent: 24px !default;\n\n$breakpoint-xs: 480px !default;\n$breakpoint-sm: 576px !default;\n$breakpoint-md: 768px !default;\n$breakpoint-lg: 992px !default;\n$breakpoint-xl: 1200px !default;\n$breakpoint-xxl: 1600px !default;\n","%pro-item-prefix {\n  &:before {\n    content: '';\n    display: inline-block;\n    width: 4px;\n    min-width: 4px;\n    height: 4px;\n    border: 1px solid $submenu-bg-color;\n    border-radius: 50%;\n    margin-right: 15px;\n    position: relative;\n    box-shadow: 1px 0px 0px $sidebar-color, 0px -1px 0px $sidebar-color, 0px 1px 0px $sidebar-color,\n      -1px 0px 0px $sidebar-color;\n  }\n}\n\n%text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.pro-sidebar {\n  .pro-menu {\n    padding-top: 10px;\n    padding-bottom: 10px;\n\n    > ul {\n      > .pro-sub-menu {\n        > .pro-inner-list-item {\n          position: relative;\n          background-color: $submenu-bg-color;\n\n          > div > ul {\n            padding-top: 15px;\n            padding-bottom: 15px;\n          }\n        }\n      }\n    }\n    a {\n      text-decoration: none;\n      color: $sidebar-color;\n      &:before {\n        content: '';\n        position: absolute;\n        top: 0;\n        right: 0;\n        bottom: 0;\n        left: 0;\n        background-color: transparent;\n      }\n      &:hover {\n        color: $highlight-color;\n      }\n    }\n    .pro-menu-item {\n      font-size: 15px;\n      &.active {\n        color: $highlight-color;\n      }\n\n      .suffix-wrapper {\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n      .prefix-wrapper {\n        display: flex;\n        margin-right: 5px;\n        opacity: 1;\n        transition: opacity 0.2s;\n      }\n\n      > .pro-inner-item {\n        position: relative;\n        display: flex;\n        align-items: center;\n        padding: 8px 35px 8px 20px;\n        cursor: pointer;\n\n        &:focus {\n          outline: none;\n          color: $highlight-color;\n        }\n        > .pro-icon-wrapper {\n          margin-right: 10px;\n          font-size: 14px;\n          width: $icon-size;\n          min-width: $icon-size;\n          height: $icon-size;\n          line-height: $icon-size;\n          text-align: center;\n          display: inline-block;\n\n          .pro-icon {\n            display: flex;\n            height: 100%;\n            align-items: center;\n            justify-content: center;\n          }\n        }\n\n        > .pro-item-content {\n          flex-grow: 1;\n          flex-shrink: 1;\n\n          @extend %text-truncate;\n        }\n\n        &:hover {\n          color: $highlight-color;\n          .pro-icon-wrapper {\n            .pro-icon {\n              animation: swing ease-in-out 0.5s 1 alternate;\n            }\n          }\n        }\n      }\n\n      &.pro-sub-menu {\n        > .pro-inner-item {\n          &:before {\n            background: $sidebar-color;\n          }\n\n          > .pro-arrow-wrapper {\n            position: absolute;\n            right: 20px;\n            top: 50%;\n            transform: translateY(-50%);\n\n            .pro-arrow {\n              display: inline-block;\n              border-style: solid;\n              border-color: $sidebar-color;\n              border-width: 0 2px 2px 0;\n              padding: 2.5px;\n              vertical-align: middle;\n              transition: transform 0.3s;\n              transform: rotate(-45deg);\n            }\n          }\n        }\n\n        &.open {\n          > .pro-inner-item {\n            &:before {\n              background: transparent !important;\n            }\n            > .pro-arrow-wrapper {\n              .pro-arrow {\n                transform: rotate(45deg);\n              }\n            }\n          }\n        }\n\n        .pro-inner-list-item {\n          padding-left: $submenu-indent;\n\n          .pro-inner-item {\n            padding: 8px 30px 8px 15px;\n\n            > .pro-icon-wrapper {\n              background: none;\n              width: auto;\n              min-width: auto;\n              height: auto;\n              line-height: auto;\n            }\n          }\n        }\n      }\n    }\n\n    &:not(.inner-submenu-arrows) {\n      .pro-inner-list-item .pro-menu-item.pro-sub-menu .pro-inner-item .pro-arrow-wrapper {\n        display: none;\n      }\n    }\n    &.submenu-bullets {\n      .pro-menu-item.pro-sub-menu .pro-inner-list-item .pro-inner-item {\n        @extend %pro-item-prefix;\n      }\n    }\n\n    &.shaped {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            background-color: $icon-bg-color;\n          }\n        }\n      }\n    }\n\n    &.square {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 0;\n          }\n        }\n      }\n    }\n    &.round {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 4px;\n          }\n        }\n      }\n    }\n    &.circle {\n      .pro-menu-item {\n        > .pro-inner-item {\n          > .pro-icon-wrapper {\n            border-radius: 50%;\n          }\n        }\n      }\n    }\n  }\n\n  // styling when the sidebar is collapsed\n\n  &.collapsed {\n    .pro-menu {\n      > ul {\n        > .pro-menu-item {\n          > .pro-inner-item {\n            > .suffix-wrapper,\n            > .prefix-wrapper {\n              opacity: 0;\n            }\n          }\n          > .pro-inner-list-item {\n            background-color: $submenu-bg-color-collapsed;\n            z-index: 111;\n          }\n          position: relative;\n          &::before {\n            content: '';\n            display: inline-block;\n            position: absolute;\n            top: 0;\n            bottom: 0;\n            left: 0;\n            right: 0;\n            cursor: pointer;\n          }\n          &.pro-sub-menu {\n            position: relative;\n\n            > .pro-inner-item {\n              pointer-events: none;\n\n              > .pro-arrow-wrapper {\n                display: none;\n              }\n            }\n            > .pro-inner-list-item {\n              height: auto !important;\n              position: fixed;\n              visibility: hidden;\n              min-width: 220px;\n              max-width: 270px;\n              background-color: transparent;\n              max-height: 100%;\n              padding-left: 3px;\n              &.has-arrow {\n                padding-left: 10px;\n              }\n              > .popper-inner {\n                max-height: 100vh;\n                overflow-y: auto;\n                background-color: $submenu-bg-color-collapsed;\n                padding-left: 20px;\n                border-radius: 4px;\n              }\n            }\n            &:hover {\n              > .pro-inner-list-item {\n                transition: visibility, transform 0.3s;\n                visibility: visible;\n              }\n              .pro-icon-wrapper {\n                .pro-icon {\n                  animation: swing ease-in-out 0.5s 1 alternate;\n                }\n              }\n            }\n\n            .pro-inner-list-item {\n              .pro-sub-menu-item,\n              .pro-inner-item {\n                padding: 8px 30px 8px 5px;\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n\n  // styles for rtl\n  &.rtl {\n    .pro-menu {\n      .pro-menu-item {\n        .prefix-wrapper {\n          margin-right: 0;\n          margin-left: 5px;\n        }\n        > .pro-inner-item {\n          padding: 8px 20px 8px 35px;\n          > .pro-icon-wrapper {\n            margin-right: 0;\n            margin-left: 10px;\n          }\n        }\n\n        &.pro-sub-menu {\n          > .pro-inner-item {\n            > .pro-arrow-wrapper {\n              right: auto;\n              left: 20px;\n              .pro-arrow {\n                transform: rotate(135deg);\n              }\n            }\n          }\n          &.open {\n            > .pro-inner-item {\n              > .pro-arrow-wrapper {\n                .pro-arrow {\n                  transform: rotate(45deg);\n                }\n              }\n            }\n          }\n\n          .pro-inner-list-item {\n            padding-left: 0;\n            padding-right: $submenu-indent;\n\n            .pro-inner-item {\n              padding: 8px 15px 8px 30px;\n              &:before {\n                margin-right: 0;\n                margin-left: 15px;\n              }\n            }\n          }\n        }\n      }\n    }\n\n    // styles for rtl and collapsed\n    &.collapsed {\n      .pro-menu {\n        > ul {\n          > .pro-menu-item {\n            &.pro-sub-menu {\n              > .pro-inner-list-item {\n                padding-left: 0;\n                padding-right: 3px;\n                &.has-arrow {\n                  padding-right: 10px;\n                }\n                > .popper-inner {\n                  padding-left: 0;\n                  padding-right: 20px;\n                }\n              }\n\n              .pro-inner-list-item {\n                .pro-sub-menu-item,\n                .pro-inner-item {\n                  padding: 8px 5px 8px 30px;\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",".popper-arrow {\n  position: absolute;\n  z-index: -1;\n  width: 0;\n  height: 0;\n  border-top: 7px solid transparent;\n  border-bottom: 7px solid transparent;\n}\n\n.popper-element[data-popper-placement^='left'] > .popper-arrow {\n  right: 0;\n  border-right: 7px solid $submenu-bg-color-collapsed;\n}\n\n.popper-element[data-popper-placement^='right'] > .popper-arrow {\n  left: 0;\n  border-left: 7px solid $submenu-bg-color-collapsed;\n}\n",".react-slidedown {\n  height: 0;\n  transition-property: none;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-in-out;\n}\n\n.react-slidedown.transitioning {\n  overflow-y: hidden;\n}\n\n.react-slidedown.closed {\n  display: none;\n}\n","@import url(\"https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n@import url(\"https://fonts.googleapis.com/css2?family=Dosis:wght@200;300;400;500;600;700&family=Poppins:ital,wght@0,100;0,200;0,300;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap\");\n\n$font-family: \"Poppins\" !default;\n$font-family-Roboto: \"Roboto\" !default;\n$font-family-Dosis: \"Dosis\" !default;\n\n$white: #fff !default;\n$light-gray: rgba(255, 255, 255, 0.5) !default;\n\n$red: #d41313 !default;\n\n$primary: #0575E6 !default;\n\n$black: #131313 !default;\n$light-black: #201f23 !default;\n$dark-black: #0e0e0e !default;\n$blue: #0575E6 !default;\n$gray: Gray !default;\n$lightgray: lightgray !default;\n$green: #42D742 !default;\n\n\n$border: 1px solid #D1D1D1 !default;\n$bold-border: 3px solid #b59b41 !default;\n\n$border-radius-10: 10px !default;\n$border-radius-20: 20px !default;\n$border-radius-24: 24px !default;\n\n$text-uppercase: uppercase !default;\n\n\n$font-8: 8px !default;\n$font-9: 9px !default;\n$font-10: 10px !default;\n$font-11: 11px !default;\n$font-12: 12px !default;\n$font-14: 14px !default;\n$font-15: 15px !default;\n$font-16: 16px !default;\n$font-17: 17px !default;\n$font-18: 18px !default;\n$font-20: 20px !default;\n$font-22: 22px !default;\n$font-24: 24px !default;\n$font-26: 26px !default;\n$font-28: 28px !default;\n$font-32: 32px !default;\n$font-36: 36px !default;\n$font-50: 50px !default;\n$font-40: 40px !default;\n$font-144: 144px !default;\n\n$font-weight-300: 300 !default;\n$font-weight-400: 400 !default;\n$font-weight-500: 500 !default;\n$font-weight-600: 600 !default;\n$font-weight-700: 700 !default;\n$font-weight-800: 800 !default;\n$font-weight-900: 900 !default;\n$font-weight-1200: 1900 !default;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
